import React, { useState, useEffect, useContext, useRef } from 'react';
import { StyleSheet, Text, Animated, View, TouchableOpacity, FlatList, Modal, TextInput, ScrollView, ActivityIndicator, Alert, Switch, Platform, AppState, PermissionsAndroid} from 'react-native';

import TcpSocket from 'react-native-tcp-socket';
import { NetworkInfo } from 'react-native-network-info';
import NetInfo, { useNetInfo } from "@react-native-community/netinfo";
import WifiManager from "react-native-wifi-reborn";
import { Dropdown } from 'react-native-element-dropdown';
import AndroidOpenSettings from 'react-native-android-open-settings'
import useWebSocket from 'react-native-use-websocket';

// import GestureRecognizer from 'react-native-swipe-gestures';

import { AntDesign, MaterialCommunityIcons, FontAwesome5, Ionicons, FontAwesome, Entypo } from '@expo/vector-icons';
// import { useFonts } from 'expo-font'

import CheckBox from '@react-native-community/checkbox';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { CredentialsContext } from '../components/CredentialsContext';
import { useNavigationState } from '@react-navigation/native';

import axios from 'axios';

import Card from '../components/Card';
import RadioButton from '../components/RadioButton';
import StyledText from '../components/StyledText';
import BoldStyledText from '../components/BoldStyledText';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';

import envVars from '../env';

const RoomModules = props => {

    const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);

    // const { sendMessage, lastJsonMessage, lastMessage, readyState } = useWebSocket('ws://185.231.115.232:5001', {  
    //     share: true,
    //     onOpen: () => {
    //         // sendMessage(JSON.stringify(welcomeMsg))
    //         console.log('connected from RoomModules')
    //     },
    //     retryOnError: true,
    //     reconnectAttempts: 15,
    //     shouldReconnect: (CloseEvent) => true,
    // })

    // const [rooms, setRooms] = useState(()=> {
    //     if(typeof storedCredentials.userRooms == 'string') return JSON.parse(storedCredentials.userRooms)
    //     else return storedCredentials.userRooms
    // });
    const [rooms, setRooms] = useState(props.rooms)

    const [addModuleModalVisible, setAddModuleModalVisile] = useState(false); 
    const [addModuleModalSecondStepVisible, setAddModuleModalSecondStepVisible] = useState(false);
    const [addModuleModalThirdStepVisible, setAddModuleModalThirdStepVisible] = useState(false);
    const [addModuleModalFourthStepVisible, setAddModuleModalFourthStepVisible] = useState(false);
    const [addModuleModalFifthStepVisible, setAddModuleModalFifthStepVisible] = useState(false);
    
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownValue, setDropdownValue] = useState(null);
    const [dropdownItems, setDropdownItems] = useState([
        {label: 'کلید', value: 'switch'},
        {label: 'پریز', value: 'plug'},
        {label: 'تهویه', value: 'A/C'}
    ])
    
    const [switchDropdownOpen, setSwitchDropdownOpen] = useState(false);
    const [switchDropdownValue, setSwitchDropdownValue] = useState(null);
    const [switchDropdownItems, setSwitchDropdownItems] = useState([
        {label: 'یک پل', value: '1'},
        {label: 'دو پل', value: '2'},
        {label: 'سه پل', value: '3'},
        {label: 'چهار پل', value: '4'}
    ])

    const [rememberModemInfo, setRememberModemInfo] = useState(false)
    const [offlineConfig, setOfflineConfig] = useState(false)

    const [modemPassword, setModemPassword] = useState("");

    const [isAddingModule, setIsAddingModule] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    
    const [seconds, setSeconds] = useState(0);

    const [modules, setModules] = useState(props.roomData.modules)
    const [setModulesHelper, setSetModulesHelper] = useState(0)

    const [isEdittingModules, setIsEdittingModules] = useState([])
    const [isEdittingModulesHelper, setIsEdittingModulesHelper] = useState(0)
    const [isEdittingModuleName, setIsEdittingModuleName] = useState([])
    const [isEdittingModuleNameHelper, setIsEdittingModuleNameHelper] = useState(0)
    const [moduleName, setModuleName] = useState()

    const [isEdittingSwitchIcon, setIsEdittingSwitchIcon] = useState([]) 
    const [isEdittingSwitchIconHelper, setIsEdittingSwitchIconHelper] = useState(0)

    const [dropDownData, setDropDownData] = useState([])
    const [isDropDownFocused, setIsDropDownFocused] = useState(false)
    const [dropDownValue, setDropDownValue] = useState(null)
    const [isReloadingWifiList, setIsReloadingWifiList] = useState(false)

    const [addingModulesStep, setAddingModuleStep] = useState(0)

    const [tempSetPoint, setTempSetPoint] = useState('')
    const [fanSetPoint, setFanSetPoint] = useState('')

    const fadeAnim = useRef(new Animated.Value(0)).current;

    const radioButtonData = [{value: <Ionicons name="sunny-sharp" size={24} color="white" />, mode: 0}, {value: <FontAwesome5 name="snowflake" size={24} color="white" /> , mode: 1}]
    const stateIndex = useNavigationState(state=> state.index)

    const strings = () => {
        if(storedCredentials.language == 'English') {
            return EnglishStrings
        } else if(storedCredentials.language == 'Arabic') {
            return ArabicStrings
        } else return PersianStrings
    }

    const middleWareServerUrl = envVars.MIDDLE_WARE_SERVER_IP + envVars.MIDDLE_WARE_SERVER_PORT
    var ws;
    var commandInterval;
    var setIsUpdatingToFalseHandlerInterval;
    var waitingForResInterval;
    var updateReqsInterval = false;
    
    const fadeIn = () => {
        Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
        }).start();
    };

    const fetchUserRoomModules = async () =>{
        const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/fetchRoomModules';
        const parsedUserDevicesInfo = JSON.parse(storedCredentials.userDevicesInfo);

        const credentials = { 
            userPhoneNumber: storedCredentials.userPhoneNumber,
            userDeviceID: parsedUserDevicesInfo[0].id,
            userDeviceInfo: parsedUserDevicesInfo[0].name,
            roomID: props.roomData.id
        };
        
        await axios.post(url, credentials)
            .then((res)=> {
                const result = res.data;
                const { message, status, data} = result;

                AsyncStorage.getItem('flowerCribCredentials').then((storedData)=> {
                    storedData = JSON.parse(storedData);
                    
                    const index = storedData.userRooms.findIndex(room => room.id == props.roomData.id);
                    storedData.userRooms[index].modules = data.userRoom;
                    
                    AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(storedData));
                    return setModules(storedData.userRooms[index].modules);
                })
                .catch((err) => console.log(err))
            
            })
            .catch((err)=> {
            //    if(Platform.OS == 'web') {
            //             window.alert("خطایی رخ داده، از اتصالتان به اینترنت مطمئن شوید.")
            //         } else {
            //             Alert.alert(
            //                 "",
            //                 "خطایی رخ داده، از اتصالتان به اینترنت مطمئن شوید.",
            //                 [{
            //                     text: strings().ok
            //                 }]
            //             );
            //         }
            });

    };

    const setIsUpdatingToFalseHandler = (updateReqsLength) => {
        if(!setIsUpdatingToFalseHandlerInterval) {
            setIsUpdating(true)
            const timer = updateReqsLength * 400
            setIsUpdatingToFalseHandlerInterval = setInterval(() => { 
                setIsUpdating(false) 
                clearInterval(setIsUpdatingToFalseHandlerInterval)
                setIsUpdatingToFalseHandlerInterval = undefined
            },  timer)
        }
    }

    const findAndDeleteItems = (arrayA, arrayB) => {
        let itemsToDelete = new Set(arrayA);
    
        for (let i = arrayB.length - 1; i >= 0; i--) {
            if (itemsToDelete.has(arrayB[i])) {
                arrayB.splice(i, 1);
            }
        }
    
        return arrayB;
    }

    // useEffect(()=> {
    //     console.log('readyState: ', readyState)
    //     if(readyState == 1) {
    //         updateModulesHandler()
    //     }
    // },[readyState])

    const updateModulesHandler = (module) => {
        const roomIndex = rooms.findIndex(room => room.id == props.roomData.id)
        const currentStateIndex = props.navProps.navigation.getState()

        if(roomIndex == currentStateIndex.index) {
            var MACsArr = [];
            if(module && module.MAC){
                MACsArr.push(module)
            } else {
                props.roomData.modules.forEach(item => {
                    MACsArr.push(item)
                })
            }
    
            setIsUpdatingToFalseHandler(MACsArr.length)
            
            var tempToken = props.rootStackProps.token
            
            const onlineUpdate = (MACsArr) => {
                // console.log("MACSArr: ",MACsArr)
                var updateReqs = [];
                
                MACsArr.forEach(arrItem=> {
                    if(arrItem.orgDID) {
                        updateReqs.push(
                            {
                                CTY : 'mgs',
                                MACs: [arrItem.MAC],
                                DID: storedCredentials.userPhoneNumber,
                                orgDID: arrItem.orgDID,
                                token: tempToken
                            }
                        )
                    } else {
                        updateReqs.push(
                            {
                                CTY : 'mgs',
                                MACs: [arrItem.MAC],
                                DID: storedCredentials.userPhoneNumber,
                                token: tempToken
                            }
                        )
                    }
                })

                if(!updateReqsInterval && updateReqs.length > 0){
                    // console.log('props: ', props.rootStackProps.socket.readyState)
                    props.rootStackProps.socket.sendMessage(JSON.stringify(updateReqs[0]))
                    // console.log('sending1: ', JSON.stringify(updateReqs[0]))
                    var intervalIndex = 1
                    if(updateReqs.length > 1) {
                        updateReqsInterval = setInterval(() => {
                            props.rootStackProps.socket.sendMessage(JSON.stringify(updateReqs[intervalIndex]))
                            // console.log('sending2: ', JSON.stringify(updateReqs[intervalIndex]))
    
                            intervalIndex++
                            if(intervalIndex == updateReqs.length) {
                                clearInterval(updateReqsInterval)
                                updateReqsInterval = false
                                // console.log('updateReqsIntervalAfterCleanin:', updateReqsInterval)
                            } 
                        },120)
                    }

                }
                

            }
    
            const offlineUpdate = () => {
                console.log('offline233')
                NetworkInfo.getIPAddress().then(ipAddress => {
                    if(ipAddress) {
                        //console.log("LOCALIP: ", ipAddress)
                        const splitedLocalIp = ipAddress.split(".")
                        //console.log("Splited IP: ", splitedLocalIp)
        
                        //console.log('Going OFFLINE...')
                        var offlineIsStarted = false
    
                        modules.forEach(module => {
        
                            var updateReq
                            if(module.orgDID) {
                                updateReq = {
                                    CTY : 'mgs',
                                    DID: module.orgDID,
                                    DIR: storedCredentials.userPhoneNumber
                                }
                            } else {
                                updateReq = {
                                    CTY : 'mgs',
                                    DID: storedCredentials.userPhoneNumber,
                                    DIR: storedCredentials.userPhoneNumber
                                }
                            }
                
                            const moduleSplitedIp = module.localIp.split(".")
                            
                            if(moduleSplitedIp[0] == splitedLocalIp[0] && moduleSplitedIp[1] == splitedLocalIp[1] && moduleSplitedIp[2] == splitedLocalIp[2]) {
                                //console.log("IP: ", module.localIp)
                                offlineIsStarted = true
                                const client = TcpSocket.createConnection({port: 9999, host: module.localIp, timeout: 5000}, ()=> {
                                // const client = TcpSocket.createConnection({port: 9999, host: '192.168.1.12', timeout: 5000}, ()=> {
                                    //console.log("SOCKET OPENED!")
                                    client.write(JSON.stringify(updateReq));
                                    
                                })  
        
                                client.on('timeout', ()=> {
                                    //console.log(module.localIp, "Timedout, destroying...")
                                    client.destroy()
                                    setIsUpdating(false)
                                    clearInterval(commandInterval)
                                })
                    
                                client.on('error', (err)=> {
                                    //console.log("ERROR: ", err)
                                    client.destroy()
                                    setIsUpdating(false)
    
                                })
                    
                                client.on('data', function(data) {
                                    var res = "";
                                    data.map(charCode=> res = res + String.fromCharCode(charCode))
                                    const parsedData = JSON.parse(res)    
                        
                                    if(parsedData.CTY == "mgsRes" && parsedData.STM) {
                                        setIsUpdating(false);
                                        const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                        const newState = {STM: parsedData.STM, RTM: parsedData.RTM, FAN: parsedData.FAN, MOD: parsedData.MOD, PWR: parsedData.PWR}
                                        const updatedModule = {...modules[index], ...{newState}, ...{isWaitingForRes: false}}
                                        clearInterval(commandInterval)
                                        var updatedModules = modules;
                                        updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                        setModules(updatedModules)
                                        setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                        
                                        // console.log(updatedModules)
                        
                                    } else if(parsedData.CTY == "mgsRes" && !parsedData.STM) {
                                        setIsUpdating(false)
                                        //console.log(parsedData.STM)
                                        const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                        const updatedModule = {...modules[index], ...{newState: parsedData.STA}, ...{isWaitingForRes: false}}
                                        clearInterval(commandInterval)
                                        var updatedModules = modules;
                                        updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                        setModules(updatedModules)
                                        setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                        
                                        // console.log(updatedModules)
                                    }
                                    
                                })
        
                            }
                        })
    
                        if(!offlineIsStarted) setIsUpdating(false)
    
                    }
                });
                    
            }

            const localUpdate = (moduleItem) => {
    
                NetworkInfo.getIPAddress().then(ipAddress => {
                    if(ipAddress) {
                        // console.log("LOCALIP: ", ipAddress)
                        const splitedLocalIp = ipAddress.split(".")
                        //console.log("Splited IP: ", splitedLocalIp)
        
                        //console.log('Going OFFLINE...')
                        var offlineIsStarted = false
                        const modulesArr = moduleItem ? [moduleItem] : modules
                        modulesArr.forEach(module => {
        
                            var updateReq
                            if(module.orgDID) {
                                updateReq = {
                                    CTY : 'mgs',
                                    DID: module.orgDID,
                                    DIR: storedCredentials.userPhoneNumber
                                
                                }
                            } else {
                                updateReq = {
                                    CTY : 'mgs',
                                    DID: storedCredentials.userPhoneNumber,
                                    DIR: storedCredentials.userPhoneNumber
                                
                                }
                            }
                
                            offlineIsStarted = true
                            const client = TcpSocket.createConnection({port: 9998, host: '192.168.200.1', timeout: 5000}, ()=> {
                                // console.log("SOCKET OPENED!")
                                client.write(JSON.stringify(updateReq));
                                
                            })  
    
                            client.on('timeout', ()=> {
                                // console.log(module.localIp, "Timedout, destroying...")
                                client.destroy()
                                setIsUpdating(false)
                                clearInterval(commandInterval)
                            })
                
                            client.on('error', (err)=> {
                                //console.log("ERROR: ", err)
                                client.destroy()
                                setIsUpdating(false)

                            })
                
                            client.on('data', function(data) {
                                var res = "";
                                data.map(charCode=> res = res + String.fromCharCode(charCode))
                                const parsedData = JSON.parse(res)    
                    
                                if(parsedData.CTY == "mgsRes" && parsedData.STM) {
                                    setIsUpdating(false);
                                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                    const newState = {STM: parsedData.STM, RTM: parsedData.RTM, FAN: parsedData.FAN, MOD: parsedData.MOD, PWR: parsedData.PWR}
                                    const updatedModule = {...modules[index], ...{newState}, ...{isWaitingForRes: false}}
                                    clearInterval(commandInterval)
                                    var updatedModules = modules;
                                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                    setModules(updatedModules)
                                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                    
                                    // console.log(updatedModules)
                    
                                } else if(parsedData.CTY == "mgsRes" && !parsedData.STM) {
                                    setIsUpdating(false)
                                    //console.log(parsedData.STM)
                                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                    const updatedModule = {...modules[index], ...{newState: parsedData.STA}, ...{isWaitingForRes: false}}
                                    clearInterval(commandInterval)
                                    var updatedModules = modules;
                                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                    setModules(updatedModules)
                                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                    
                                    // console.log(updatedModules)
                                }
                                
                            })
                        })
    
                        if(!offlineIsStarted) setIsUpdating(false)
    
                    }
                });
                    
            }
            
            // if(props.rootStackProps.socket.readyState !== 1){
            // console.log('readyState111: ',readyState)
            if(Platform.OS == 'web') {
                onlineUpdate(MACsArr);
            } else {
                setIsUpdating(true)
                offlineUpdate();        
                onlineUpdate(MACsArr);
            }
            const wifiNetworks = storedCredentials.wifiNetworks
            if(wifiNetworks){
                var localModules = []
                wifiNetworks.forEach(wifiNetwork => {
                    if(wifiNetwork.SSID.substring(0,6) === 'Zitco_'){
                        MACsArr.forEach(item => {
                            if(wifiNetwork.SSID.substring(6,8) === item.MAC.substring(12,14) && wifiNetwork.SSID.substring(8,10) === item.MAC.substring(15,18) ){
                                WifiManager.getCurrentWifiSSID().then(ssid => {
                                    if(ssid.substring(6,8) === item.MAC.substring(12,14) && ssid.substring(8,10) === item.MAC.substring(15,18) ){
                                        localUpdate(item)
                                        localModules.push(item) 
                                    } else {
                                        checkForNearbyModule(item.MAC)
                                    }
                                })
                            }
                        })
                    }
                })
                
            }
        }

        

    } 

    useEffect(() => {
        const focusedListener = props.navProps.navigation.addListener('focus', () => {
            if(updateReqsInterval) clearInterval(updateReqsInterval)
            const roomIndex = rooms.findIndex(room => room.id == props.roomData.id)
            const currentStateIndex = props.navProps.navigation.getState()
    
            if(roomIndex == currentStateIndex.index) {

                const HeaderTitleComponent = () => {
                    return(
                        <TouchableOpacity 
                            style={{backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#e88804', borderRadius: 10, padding: 7, paddingHorizontal: 15, justifyContent: 'center', alignItems: 'center', margin: 2, flexDirection: 'row' }}
                            onPress={() => {isUpdating || !props.rootStackProps.isTokenValidated ? {} : updateModulesHandler() }}
                        >
                            {props.rootStackProps.isTokenValidated ?
                                <>
                                    <BoldStyledText style={{fontSize: 22, color: 'white'}}> {isUpdating ? strings().updating : strings().update} </BoldStyledText>
                                    {isUpdating && <ActivityIndicator size={'small'} color={'white'} /> } 
                                </>
                            
                            :
                                <BoldStyledText style={{fontSize: isUpdating ? 25 : 35, color: storedCredentials.theme == 'light' ? 'blue' : '#e88804'}}> {strings().connecting} </BoldStyledText>
                            }
                        </TouchableOpacity>   
                    )
                }

                props.rootStackProps.navigation.setOptions({
                    headerTitle: () => <HeaderTitleComponent />,
                    headerTitleAlign: 'center',
                    headerTitleStyle:{
                        fontSize: isUpdating ? 25 : 35,
                    },
                    headerStyle:{
                        backgroundColor: storedCredentials.theme == "light" ? '#f2f2f2' : '#3b3c37' 
                    }, 
                    headerRight: () => (
                        <View style={{justifyContent: 'center'}}>
            
                            <TouchableOpacity 
                                // style={{paddingRight: 17}}
                                onPress={()=>{
                                }}
                            >
                                <TouchableOpacity 
                                    style={{padding: 5, borderRadius: 15}}
                                    onPress={()=> {
                                        setIsUpdating(false)
                                        setAddModuleModalVisile(!addModuleModalVisible)
            
                                    }}
                                >
                                    <Ionicons name="add-circle-outline" size={40} color={storedCredentials.theme == 'light' ? 'black' : 'white'} />
            
                                    
                                </TouchableOpacity>
            
                            </TouchableOpacity>
                        </View>
                    ),
                    headerTintColor: storedCredentials.theme == "light" ? 'black' : 'white' 
                    
                });

                setModules(props.roomData.modules)
                setSetModulesHelper(setModulesHelper => setModulesHelper + 1 )
                updateModulesHandler();
            }
        })

        return focusedListener

    }, [props.navProps.navigation])

    //Handeling modules response
    useEffect(()=> {
        const roomIndex = rooms.findIndex(room => room.id == props.roomData.id)
        const currentStateIndex = props.navProps.navigation.getState()
        if(roomIndex == currentStateIndex.index) {
            if(props.rootStackProps.socket.lastMessage) {
                const parsedData = props.rootStackProps.socket.lastMessage            
                // console.log("parsedData: ", parsedData)
                if(parsedData.CTY) {
                    if(parsedData.CTY == "mgsRes" && parsedData.STM) {
                        const moduleRestInterval = setInterval(() => {
                            clearInterval(moduleRestInterval)
                            const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                            const newState = {STM: parsedData.STM, RTM: parsedData.RTM, FAN: parsedData.FAN, MOD: parsedData.MOD, PWR: parsedData.PWR}
                            const updatedModule = {...modules[index], ...{newState}, ...{isWaitingForRes: false}}
                            var updatedModules = modules;
                            updatedModules[index] = {...updatedModules[index], ...updatedModule}
                            setModules(updatedModules)
                            setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                            
                        }, 500);
                    } else if(parsedData.CTY == "mgsRes" && !parsedData.STM) {
                        // console.log('parsedData: ', parsedData)
                        const moduleRestInterval = setInterval(() => {
                            // console.log('got2')
                            clearInterval(moduleRestInterval)
                            const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                            const updatedModule = {...modules[index], ...{newState: parsedData.STA}, ...{isWaitingForRes: false}}
                            var updatedModules = modules;
                            updatedModules[index] = {...updatedModules[index], ...updatedModule}
                            setModules(updatedModules)
                            setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                
                        }, 500);
                    }
    
                }
    
            }

        }

    },[props.rootStackProps.socket.lastMessage])

    useEffect(()=> {


    },[isUpdating]) 

    useEffect(() => {
        const roomIndex = rooms.findIndex(room => room.id == props.roomData.id)
        const currentStateIndex = props.navProps.navigation.getState()
        if(updateReqsInterval) clearInterval(updateReqsInterval)
        if(roomIndex == currentStateIndex.index) {

            // if(storedCredentials.modemInfo) {
            //     // setSSID(storedCredentials.modemInfo.ssid)

            //     setModemPassword(storedCredentials.modemInfo.password)
            // }

            const HeaderTitleComponent = () => {
                return(
                    <TouchableOpacity 
                        style={{backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#e88804', borderRadius: 10, padding: 7, paddingHorizontal: 15, justifyContent: 'center', alignItems: 'center', margin: 2, flexDirection: 'row' }}
                        onPress={() => {isUpdating ? {} : updateModulesHandler() }}
                    >
                        <BoldStyledText style={{fontSize: 22, color: 'white'}}> {isUpdating ? strings().updating : strings().update} </BoldStyledText>
                        {isUpdating && <ActivityIndicator size={'small'} color={'white'} /> } 
                    </TouchableOpacity>   
                )
            }
        
            props.rootStackProps.navigation.setOptions({
                headerTitle: () => <HeaderTitleComponent />,
                headerTitleAlign: 'center',
                headerTitleStyle:{
                    fontSize: isUpdating ? 25 : 35,
                },
                headerStyle:{
                    backgroundColor: storedCredentials.theme == "light" ? '#f2f2f2' : '#3b3c37' 
                }, 
                headerRight: () => (
                    <View style={{justifyContent: 'center'}}>
        
                        <TouchableOpacity 
                            // style={{paddingRight: 17}}
                            onPress={()=>{
                            }}
                        >
                            <TouchableOpacity 
                                style={{padding: 5, borderRadius: 15}}
                                onPress={()=> {
                                    setIsUpdating(false)
                                    setAddModuleModalVisile(!addModuleModalVisible)
        
                                }}
                            >
                                <Ionicons name="add-circle-outline" size={40} color={storedCredentials.theme == 'light' ? 'black' : 'white'} />
        
                                
                            </TouchableOpacity>
        
                        </TouchableOpacity>
                    </View>
                ),
                headerTintColor: storedCredentials.theme == "light" ? 'black' : 'white' 
                
            });

            // fetchUserRoomModules();
            setModules(props.roomData.modules)
            setSetModulesHelper(setModulesHelper => setModulesHelper + 1 )
            updateModulesHandler();
        }

    },[])

    useEffect(() => {
        if(Platform.OS == 'web') {
            const appStateListener = AppState.addEventListener('change',currentAppState => {
                if(currentAppState == 'active'){
                    const roomIndex = rooms.findIndex(room => room.id == props.roomData.id)
                    const currentStateIndex = props.navProps.navigation.getState()
    
                    if(roomIndex == currentStateIndex.index) {
    
                        // fetchUserRoomModules();
                        setModules(props.roomData.modules)
                        setSetModulesHelper(setModulesHelper => setModulesHelper + 1 )
                        console.log('heree2')
                        updateModulesHandler();
            
                    }
                
                }
            });
    
            return () => {
              appStateListener?.remove();
            };

        }
    }, []);

    useEffect(() => {
        if(seconds > 5) {
            if(Platform.OS == 'web') {
                window.alert(strings().anErrorOccurredWhileConnectingToDevicePleaseTryAgain)
            } else {
                Alert.alert(
                    "",
                    strings().anErrorOccurredWhileConnectingToDevicePleaseTryAgain,
                    [{
                        text: strings().ok
                    }]
                );
            }
            setSeconds(0)
            setIsAddingModule(false)
        }

    },[seconds])

    useEffect(()=> {
        // console.log('dropDownValue: ', dropDownValue)
        if(storedCredentials.modemInfo) {
            if(storedCredentials.modemInfo.ssid == dropDownValue) {
                setModemPassword(storedCredentials.modemInfo.password)
            } else {
                setModemPassword('')
            }
        } 

    },[dropDownValue])

    const openWifiSettings = () => {
        AndroidOpenSettings.wifiSettings()
    }

    const generatePassword = ssid => {
        const middleChars = ssid.substring(6, 10);
        const modifiedString = middleChars.substring(0, 2) + ':' + middleChars.substring(2);

        var MAC = ''
        storedCredentials.userRooms.forEach(room => {
            room.modules.forEach(module => {
                if(module.MAC.slice(-5) === modifiedString){
                    MAC = module.MAC
                }
            })
        })

        const pass = MAC + '@zitP'
        return pass
        
    }

    const checkForNearbyModule = async (MAC) => {
        const isWifiEnabled = await WifiManager.isEnabled()
        if(isWifiEnabled) {
            try{
                const granted = await PermissionsAndroid.request(
                    PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
                    {
                        title: strings().requestForWifiPermission,
                        message: strings().ZitkitNeedsThisPermissionToConnectToYourSmartSwitch,
                        buttonNeutral: strings().notNow,
                        buttonNegative: strings().notAllowed,
                        buttonPositive: strings().Allowed
                    },
                )
    
                if(granted == PermissionsAndroid.RESULTS.GRANTED){
                    WifiManager.reScanAndLoadWifiList().then(wifiList => {
                        // console.log("WifiList: ", wifiList)
                        if(wifiList.length) {
                            console.log('founded networks:', wifiList.length)
                            wifiList.forEach(wifiNetwork => {
                                if(wifiNetwork.SSID === 'ZITCO_config'){
                                    WifiManager.connectToProtectedSSID(wifiNetwork.SSID, '123456789', false).then(
                                        () => {
                                            setAddModuleModalSecondStepVisible(!addModuleModalSecondStepVisible)
                                            setAddModuleModalThirdStepVisible(!addModuleModalThirdStepVisible)
                                            // requestAccessFineLocation()
                                        },
                                        (err) => {
                                            console.log('ConnectingErr: ', err)
                                        }
                                    )
                                    // return
                                } else if(MAC) {
                                    if(wifiNetwork.SSID.substring(0,6) === 'Zitco_' 
                                    && wifiNetwork.SSID.substring(6,8) === MAC.substring(12,14) 
                                    && wifiNetwork.SSID.substring(8,10) === MAC.substring(15,18)){
                                        const psl = generatePassword(wifiNetwork.SSID)

                                        WifiManager.connectToProtectedSSID(wifiNetwork.SSID, psl, false).then(
                                            () => {
                                                console.log("Connected!")
                                                updateModulesHandler()
                                            },
                                            (err) => {
                                                askForTurningWifiOnHandlerFunc()
                                                console.log('ask for connecting turned off')
                                                console.log('err2: ', err)
                                            }
                                        )
                                    }
                                }
                            })

                        }
                    }).catch(err =>{
                        console.log('err: ', err)
                        Alert.alert(
                            "",
                            strings().pleaseTurnOnLocationService,
                            [{
                                text: strings().ok,
                                onPress: () => { 
                                    AndroidOpenSettings.locationSourceSettings()
                                }
                            }]
                        );
                })
                } else {
                    Alert.alert(
                        "",
                        strings().permissionDenied,
                        [{
                            text: strings().ok
                        }]
                    );            
                }
            } catch(err) {
                console.log('err1: ',err)
            }
        } else {
            Alert.alert(
                '',
                strings().toUseOfflineUsageYouShouldEnableWifi,
                [
                    { text: strings().deny, style: 'cancel'},
                    { text: strings().ok, onPress: openWifiSettings }
                ],
                { cancelable: false}
            )
        }
    
    }

    useEffect(() => {
        if(addModuleModalSecondStepVisible){
            checkForNearbyModule()
        }
    },[addModuleModalSecondStepVisible])

    const handleAddNewModule = () => {
        if(rememberModemInfo) {
            const updatedStoredCredentials = {...storedCredentials, ...{modemInfo:{ssid: dropDownValue, password: modemPassword}}}
            
            AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
            .then(()=> {
                setStoredCredentials(updatedStoredCredentials)
            })
            .catch(err =>{
                console.log(err);
            })
        }

        if(Platform.OS != 'web') {
            const serverIP = envVars.SERVER_URL.replace("http://", "");

            const data = [
                { SSD : dropDownValue },
                { PAS : modemPassword },
                { DID : storedCredentials.userPhoneNumber },
                // { MTY : setModuleType() },
                { RID: props.roomData.id },
                { SIP: envVars.SERVER_URL },
                { SPO: 8080 }
            ];
            const data0 = "{XMAC}"
            const data1 = { SSD : dropDownValue }
            // const data1 = { SSD : 'UTEL' }
            const data2 = { PAS : modemPassword }
            const data3 = { DID : storedCredentials.userPhoneNumber }
            // const data4 = { MTY : setModuleType() }
            const data4 = { RID: props.roomData.id }
            var data5 = { LSS: "NNNNNNNNNN" } 
            var data6 = { PSL: "NNNNNNNNNN" }
            const data7 = { SIP: serverIP }
            const data8 = { SPO: "8080" }

            // if(dropDownValue == null || modemPassword == "") {
            if(modemPassword == "") {
                if(Platform.OS == 'web') {
                    window.alert(strings().pleaseEnterRequestedInformations)
                } else{
                    Alert.alert('',strings().pleaseEnterRequestedInformations,[
                        {
                            text: strings().ok
                        }
                    ])
                }
            } else {
                setIsAddingModule(true);

                var interval = null;
                const timeout = 5000;

                //console.log("OPENING SOCKET...")
                NetInfo.fetch().then(state => {
                    // console.log( 'ssid: ', state.details.ssid)
                    // if(state.details.ssid == 'ZITCO_config') {
                        const clientSocket = TcpSocket.createConnection({port: 9999,host: '192.168.4.1'}, () =>{
                            // const clientSocket = TcpSocket.createConnection({port: 9999,host: '172.20.10.5'}, () =>{
                            clientSocket.on('connect', ()=> setAddingModuleStep(1) )
                            if(offlineConfig){
                                clientSocket.write(data0);
                                setAddingModuleStep(1)
                                var tries = 0;
                                interval = setInterval(() => {
                                    tries = tries + 1;
                                    if(tries <= 5) {
                                        clientSocket.write(data0);
                                    } else {
                                        clearInterval(interval);
                                        setSeconds(tries)
                                    }
                                },timeout)
                            } else {
                                clientSocket.write(JSON.stringify(data1))
                                setAddingModuleStep(1)
                                var tries = 0;
                                interval = setInterval(() => {
                                    tries = tries + 1;
                                    if(tries <= 5) {
                                        clientSocket.write(JSON.stringify(data1))
                                    } else {
                                        clearInterval(interval);
                                        setSeconds(tries)
                                    }
                                },timeout)
                            }
                        })
                        clientSocket.on('data', function(data) {
                            try{
                                var res = "";
                                data.map(charCode=> res = res + String.fromCharCode(charCode))
                                const parsedRes = res   
                                
                                clearInterval(interval);
                                setSeconds(0);
                                // console.log("ParsedRes:", parsedRes)

                                if(parsedRes.substring(2,5) == "MAC") {
                                    if(parsedRes.length == 27){
                                        if(offlineConfig){
                                            const lss = "Zitco_" + parsedRes[20] + parsedRes[21] + parsedRes[23] + parsedRes[24]
                                            const psl = parsedRes.substring(8,25) + "@zitP"
                                            data5 = { LSS: lss }
                                            data6 = { PSL : psl }
                                            // console.log('PSL:', data6);
                                        }
                                        // console.log(JSON.stringify(data1))
                                        clientSocket.write(JSON.stringify(data1))
                                    } else {
                                        clientSocket.write(data0)
                                    }
                                } else if(parsedRes == JSON.stringify(data1)) {
                                    clientSocket.write(JSON.stringify(data2));
                                    setAddingModuleStep(2)
                                    var tries = 0
                                    interval = setInterval(() => {
                                        tries = tries + 1;
                                        if(tries <= 5) {
                                            clientSocket.write(JSON.stringify(data2));
                                        } else {
                                            clearInterval(interval);
                                            setSeconds(tries)
                                        }
                                    },timeout)
                                } else if(parsedRes == JSON.stringify(data2)) {
                                    clientSocket.write(JSON.stringify(data3));
                                    setAddingModuleStep(3)
                                    var tries = 0
                                    interval = setInterval(() => {
                                        tries = tries + 1;
                                        if(tries <= 5) {
                                            clientSocket.write(JSON.stringify(data3));
                                        } else {
                                            clearInterval(interval);
                                            setSeconds(tries)
                                        }
                                    },timeout)
                                } else if(parsedRes == JSON.stringify(data3)) {
                                    clientSocket.write(JSON.stringify(data4));
                                    setAddingModuleStep(4)
                                    var tries = 0
                                    interval = setInterval(() => {
                                        tries = tries + 1;
                                        if(tries <= 5) {
                                            clientSocket.write(JSON.stringify(data4));
                                        } else {
                                            clearInterval(interval);
                                            setSeconds(tries)
                                        }
                                    },timeout)
                                } else if(parsedRes == JSON.stringify(data4)) {
                                    if(offlineConfig){
                                        clientSocket.write(JSON.stringify(data5));
                                    } else {
                                        clientSocket.write(JSON.stringify(data7))
                                    }
                                    setAddingModuleStep(5)
                                    var tries = 0
                                    interval = setInterval(() => {
                                        tries = tries + 1;
                                        if(tries <= 5) {
                                            clientSocket.write(JSON.stringify(data5));
                                        } else {
                                            clearInterval(interval);
                                            setSeconds(tries)
                                        }
                                    },timeout)
                                } else if(parsedRes == JSON.stringify(data5)) {

                                    clientSocket.write(JSON.stringify(data6));
                                    setAddingModuleStep(6)
                                    var tries = 0
                                    interval = setInterval(() => {
                                        tries = tries + 1;
                                        if(tries <= 5) {
                                            clientSocket.write(JSON.stringify(data6));
                                        } else {
                                            clearInterval(interval);
                                            setSeconds(tries)
                                        }
                                    },timeout)
                                } else if(parsedRes == JSON.stringify(data6)) {
                                    clientSocket.write(JSON.stringify(data7));
                                    setAddingModuleStep(7)
                                    var tries = 0
                                    interval = setInterval(() => {
                                        tries = tries + 1;
                                        if(tries <= 5) {
                                            clientSocket.write(JSON.stringify(data7));
                                        } else {
                                            clearInterval(interval);
                                            setSeconds(tries)
                                        }
                                    },timeout)
                                } else if(parsedRes == JSON.stringify(data7)) {
                                    clientSocket.write(JSON.stringify(data8));
                                    setAddingModuleStep(8)
                                    var tries = 0
                                    interval = setInterval(() => {
                                        tries = tries + 1;
                                        if(tries <= 5) {
                                            clientSocket.write(JSON.stringify(data8));
                                        } else {
                                            clearInterval(interval);
                                            setSeconds(tries)
                                        }
                                    },timeout)
                                } else if(parsedRes == JSON.stringify(data8)) {
                                    setAddingModuleStep(9)
                                    setIsAddingModule(false)
                                    clientSocket.destroy();
                                    if(Platform.OS == 'web') {
                                        window.alert('دستگاه با موفقیت ثبت شد')
                                        setAddModuleModalFifthStepVisible(!addModuleModalFifthStepVisible),
                                        fetchUserRoomModules();
                                    } else {
                                        Alert.alert('',strings().dataSusseccfullySentToDevicePleaseCloseAppAndConnectToInternet,[
                                            {
                                                text: strings().ok,
                                                onPress: ()=> {
                                                    setAddModuleModalFifthStepVisible(!addModuleModalFifthStepVisible),
                                                    fetchUserRoomModules();
                                                }
                                            }
                                        ])
                                    }
                                    
                                } else if(parsedRes == 's0') {
                                } else {
                                    setIsAddingModule(false);
                                    clientSocket.write(' this message is sent after checking for proper message.')
                                    clientSocket.write(' bare recieved msg:' + data)
                                    
                                    clientSocket.destroy();
                                    if(Platform.OS == 'web') {
                                        window.alert(strings().anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork)
                                        setAddModuleModalFifthStepVisible(!addModuleModalFifthStepVisible)
                                    } else {
                                        // const alertMsg = "alert msg:" + parsedRes + "////" + buf + "////" + data
            
                                        Alert.alert('',strings().anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork,[
                                            {
                                                text: strings().ok,
                                                onPress: ()=> setAddModuleModalFifthStepVisible(!addModuleModalFifthStepVisible)
                                            }
                                        ])
                                    }
                                }
        
                            } catch(err) {
                                clientSocket.write('we fall in catch block!')
                                clientSocket.write("err is:" + err)
        
                                clientSocket.destroy();
                            }
                            if(seconds > 5) {
                                clientSocket.destroy();
                            }
                            clientSocket.on('error', function(error) {
                                //console.log(error);
                                if(Platform.OS == 'web') {
                                    window.alert(strings().anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork)
                                    setIsAddingModule(false)
                                } else {
                                    Alert.alert('',strings().errorInSocketConnection,[
                                        {
                                            text: strings().ok,
                                            onPress: ()=> setIsAddingModule(false)
                                        }
                                    ])
                                }
                                
                            });

                        });


                    // } else {
                    //     if(Platform.OS == 'web') {
                    //         const res = window.alert(strings().anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork)
                    //       } else {
                    //         Alert.alert('',strings().anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork,[
                    //           {
                    //             text: strings().ok,
                    //             onPress: ()=> setIsAddingModule(false)
                    //           }
                    //         ])
                    //       }
                    // }
                })
                
            }
        
        } else {
            window.alert(strings().deviceConfigurationIsNotPossibleWithWebApplication)
        }
        
    }

    const requestAccessFineLocation = async () => {
        setIsReloadingWifiList(true)

        try{
            const granted = await PermissionsAndroid.request(
                PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
                {
                    title: strings().requestForWifiPermission,
                    message: strings().ZitkitNeedsThisPermissionToConnectToYourSmartSwitch,
                    buttonNeutral: strings().notNow,
                    buttonNegative: strings().notAllowed,
                    buttonPositive: strings().Allowed
                },
            )

            if(granted == PermissionsAndroid.RESULTS.GRANTED){
                WifiManager.loadWifiList().then(wifiList => {
                    // console.log("WifiList: ", wifiList)
                    if(wifiList.length) {
                        var tempDropDownData = []
                        wifiList.forEach(wifiNetwork => tempDropDownData.push({label: wifiNetwork.SSID, value: wifiNetwork.SSID}))
                        setDropDownData(tempDropDownData)
                        setSetModulesHelper(setModulesHelper => setModulesHelper + 1)

                        setIsReloadingWifiList(false)
                    }
                }).catch(err =>{
                    Alert.alert(
                        "",
                        strings().pleaseTurnOnLocationService,
                        [{
                            text: strings().ok,
                            onPress: () => { 
                                setAddModuleModalThirdStepVisible(false) 
                                setIsReloadingWifiList(false)
                            }
                        }]
                    );
            })
            } else {
                Alert.alert(
                    "",
                    strings().permissionDenied,
                    [{
                        text: strings().ok,
                        onPress: () => { 
                            setAddModuleModalThirdStepVisible(false) 
                            setIsReloadingWifiList(false)
                        }
                    }]
                );            }
        } catch(err) {
            console.log(err)
        }

    }

    const moduleTypeHandler = (module) => {
        if(storedCredentials.customModulesNames) {
            const index = storedCredentials.customModulesNames.findIndex(moduleItem => moduleItem.MAC == module.item.MAC )
            if(index != -1) {
                return storedCredentials.customModulesNames[index].Name
            } else {
                if( module.item.type == "P" ){
                    return strings().plug
                } else if ( module.item.type == "A1") {
                    return strings().AC
                } else if ( module.item.type == "S1") {
                    return strings().switch
                } else if ( module.item.type == "S2") {
                    return strings().switch
                } else if ( module.item.type == "S3") {
                    return strings().switch
                } else if ( module.item.type == "S4") {
                    return strings().switch
                } else if ( module.item.type == "A2") {
                    return strings().AC
                }
            }
        } else {
            if( module.item.type == "P" ){
                return strings().plug
            } else if ( module.item.type == "A1") {
                return strings().AC
            } else if ( module.item.type == "S1") {
                return strings().switch
            } else if ( module.item.type == "S2") {
                return strings().switch
            } else if ( module.item.type == "S3") {
                return strings().switch
            } else if ( module.item.type == "S4") {
                return strings().switch
            } else if ( module.item.type == "A2") {
                return strings().AC
            }

        }
    }
    
    const handleSwitchIcon = (module, switchNum) => {
        if(storedCredentials.customSwitchesIcons){
            const moduleIndex = storedCredentials.customSwitchesIcons.findIndex(moduleItem => moduleItem.MAC == module.MAC)
            if(moduleIndex == -1){
                return 'lightbulb-on'
            } else {
                const switchIndex = storedCredentials.customSwitchesIcons[moduleIndex].Switches.findIndex(switchItem => switchItem.num == switchNum)
                if(switchIndex == -1) {
                    return 'lightbulb-on'
                } else {
                    return storedCredentials.customSwitchesIcons[moduleIndex].Switches[switchIndex].icon
                }
            }
        } else {
            return 'lightbulb-on'
        }
    }

    const moduleCommandHandler = (module, switchNum) => {
        const index = modules.findIndex(moduleItem => moduleItem.MAC == module.MAC)
        const updatedModule = {...modules[index],...{isWaitingForRes: true}}
        var updatedModules = modules
        updatedModules[index] = {...updatedModules[index], ...updatedModule}
        setModules(updatedModules)
        setSetModulesHelper(setModulesHelper => setModulesHelper + 1)

        var tempToken = '123'
        var t2 = -5
        commandInterval = setInterval(() => {
            t2++
            //console.log('t2: ' + t2)
            if(t2 >= 0) {
                if(modules[index].isWaitingForRes){
                    updateModulesHandler(module)
                    clearInterval(commandInterval)
                } else {
                    clearInterval(commandInterval)
                }
            }
        }, 1000);

        //console.log("modulesFromCommandHandler: " + JSON.stringify(modules))

        const onlineModuleCommandHandler = (module, switchNum) => {
            const typeOfModule = typeof module.newState

            const toggleSwitchState = (num) => {
                if(switchState[num] == 0) {
                    return 1
                } else if(switchState[num] == 1) {
                    return 0
                }
    
            }

            var  commmandObj;
            if(typeOfModule == 'string') {
                var switchState = [...module.newState]
                switchState[switchNum] = toggleSwitchState(switchNum)
                const command = switchState.toString().replace(/,/g,'');
    
                if(module.orgDID){
                    commmandObj = {
                        CTY: 'mr',
                        STA: command,
                        DID: module.orgDID,
                        MAC: module.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        token: tempToken
                    }
                } else {
                    commmandObj = {
                        CTY: 'mr',
                        STA: command,
                        DID: storedCredentials.userPhoneNumber,
                        MAC: module.MAC,
                        DIR: storedCredentials.userPhoneNumber,
                        token: tempToken
                    }
                }
                
            } else {
                if(switchNum.MOD) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]

                    moduleState.MOD = switchNum.MOD
                    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }

                    }
                } else if (switchNum.PWR) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]

                    moduleState.PWR = switchNum.PWR
                    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }    
                        // console.log(commmandObj)
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }

                    }
                } else if (switchNum.STM) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]

                    moduleState.STM = switchNum.STM
    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }

                    }
                } else if (switchNum.FAN) {
                    var moduleState = module.newState
                    delete moduleState.RTM

                    if(moduleState.FAN[0] == 0) {
                        if(module.type == 'A1'){
                            moduleState.FAN = '2'
                        } else if (module.type == 'A2') {
                            moduleState.FAN = '5'
                        }
                    } else {
                        moduleState.FAN = switchNum.FAN
                    }

                    if(module.type == 'A2') {
                        if(switchNum.FAN == "8" || switchNum.FAN == "0"){
                            moduleState.FAN = '0'
                        } 
                    } else if(module.type == 'A1') {
                        if(switchNum.FAN == "4" || switchNum.FAN == "0"){
                            moduleState.FAN = '0'
                        }
                    }
                    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState,
                            token: tempToken
                        }

                    }
                }
            }

            props.rootStackProps.socket.sendMessage(JSON.stringify(commmandObj))
            // console.log('from onlineModuleCommandHandler: ', JSON.stringify(commmandObj))
            // updateModulesHandler(module)
        }

        const offlineModuleCommandHandler = (module, switchNum) => {
            const typeOfModule = typeof module.newState

            const toggleSwitchState = (num) => {
                if(switchState[num] == 0) {
                    return 1
                } else if(switchState[num] == 1) {
                    return 0
                }
    
            }
            
            let commmandObj
            if(typeOfModule == 'string') {
                var switchState = [...module.newState]
                switchState[switchNum] = toggleSwitchState(switchNum)
                const command = switchState.toString().replace(/,/g,'')
                
                if(module.orgDID) {
                    commmandObj = {
                        CTY: 'mr',
                        STA: command,
                        DID: module.orgDID,
                        MAC: module.MAC,
                        DIR: storedCredentials.userPhoneNumber
                    }
                } else {
                    commmandObj = {
                        CTY: 'mr',
                        STA: command,
                        DID: storedCredentials.userPhoneNumber,
                        MAC: module.MAC,
                        DIR: storedCredentials.userPhoneNumber
                    }
                }
                
            } else {
                if(switchNum.MOD) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]

                    moduleState.MOD = switchNum.MOD
     
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                } else if (switchNum.PWR) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]

                    moduleState.PWR = switchNum.PWR
    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                } else if (switchNum.STM) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]
                    
                    moduleState.STM = switchNum.STM
    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                } else if (switchNum.FAN) {
                    var moduleState = module.newState
                    delete moduleState.RTM

                    if(moduleState.FAN[0] == 0) {
                        if(module.type == 'A1'){
                            moduleState.FAN = '2'
                        } else if (module.type == 'A2') {
                            moduleState.FAN = '5'
                        }
                    } else {
                        moduleState.FAN = switchNum.FAN
                    }

                    if(module.type == 'A2') {
                        if(switchNum.FAN == "8" || switchNum.FAN == "0"){
                            moduleState.FAN = '0'
                        } 
                    } else if(module.type == 'A1') {
                        if(switchNum.FAN == "4" || switchNum.FAN == "0"){
                            moduleState.FAN = '0'
                        }
                    }
                    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                }
            }

            NetworkInfo.getIPAddress().then(ipAddress => {
                if(ipAddress){
                    const splitedLocalIp = ipAddress.split(".")
                    //console.log("Splited IP: ", splitedLocalIp)
                    const moduleSplitedIp = module.localIp.split(".")
    
                    if( moduleSplitedIp[0] == splitedLocalIp[0] && moduleSplitedIp[1] == splitedLocalIp[1] && moduleSplitedIp[2] == splitedLocalIp[2] ) {
                        const client = TcpSocket.createConnection({port:9999,host: module.localIp, timeout: 2000}, () =>{
                            client.write(JSON.stringify(commmandObj));
                            // updateModulesHandler(module)
                        }) 
    
                        client.on('timeout', ()=> {
                            client.destroy()
                        })
    
                        client.on('data', function(data) {
                            var res = "";
                            data.map(charCode=> res = res + String.fromCharCode(charCode))
                            const parsedData = JSON.parse(res)
                            
                            client.destroy();
                            
                            if(parsedData.CTY == "mgsRes" && parsedData.STM) {
                                const moduleRestInterval = setInterval(() => {
                                    clearInterval(moduleRestInterval)
                                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                    const newState = {STM: parsedData.STM, RTM: parsedData.RTM, FAN: parsedData.FAN, MOD: parsedData.MOD, PWR: parsedData.PWR}
                                    const updatedModule = {...modules[index], ...{newState}, ...{isWaitingForRes: false}}
                                    clearInterval(commandInterval)
                                    var updatedModules = modules;
                                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                    setModules(updatedModules)
                                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                
                                }, 500);
                
                                //console.log(updatedModules)
                                return true
                
                            } else if(parsedData.CTY == "mgsRes" && !parsedData.STM) {
                                //console.log(parsedData.STM)
                                const moduleRestInterval = setInterval(() => {
                                    clearInterval(moduleRestInterval)
                                    const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                    const updatedModule = {...modules[index], ...{newState: parsedData.STA}, ...{isWaitingForRes: false}}
                                    clearInterval(commandInterval)
                                    var updatedModules = modules;
                                    updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                    setModules(updatedModules)
                                    setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                
                                }, 500);
                                
                                //console.log(updatedModules)
            
                                return true
                            }
            
                        })        
    
                    }

                }

            });
            

            
        }

        const localModuleCommandHandler = (module, switchNum) => {
            const typeOfModule = typeof module.newState
            // console.log('module.localIp: ', module.localIp);
            const toggleSwitchState = (num) => {
                if(switchState[num] == 0) {
                    return 1
                } else if(switchState[num] == 1) {
                    return 0
                }
    
            }
            
            let commmandObj
            if(typeOfModule == 'string') {
                var switchState = [...module.newState]
                switchState[switchNum] = toggleSwitchState(switchNum)
                const command = switchState.toString().replace(/,/g,'')
                
                if(module.orgDID) {
                    commmandObj = {
                        CTY: 'mr',
                        STA: command,
                        DID: module.orgDID,
                        MAC: module.MAC,
                        DIR: storedCredentials.userPhoneNumber
                    }
                } else {
                    commmandObj = {
                        CTY: 'mr',
                        STA: command,
                        DID: storedCredentials.userPhoneNumber,
                        MAC: module.MAC,
                        DIR: storedCredentials.userPhoneNumber
                    }
                }
                
            } else {
                if(switchNum.MOD) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]

                    moduleState.MOD = switchNum.MOD
     
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                } else if (switchNum.PWR) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]

                    moduleState.PWR = switchNum.PWR
    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                } else if (switchNum.STM) {
                    var moduleState = module.newState
                    delete moduleState.RTM
                    moduleState.FAN = moduleState.FAN[0]
                    
                    moduleState.STM = switchNum.STM
    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                } else if (switchNum.FAN) {
                    var moduleState = module.newState
                    delete moduleState.RTM

                    if(moduleState.FAN[0] == 0) {
                        if(module.type == 'A1'){
                            moduleState.FAN = '2'
                        } else if (module.type == 'A2') {
                            moduleState.FAN = '5'
                        }
                    } else {
                        moduleState.FAN = switchNum.FAN
                    }

                    if(module.type == 'A2') {
                        if(switchNum.FAN == "8" || switchNum.FAN == "0"){
                            moduleState.FAN = '0'
                        } 
                    } else if(module.type == 'A1') {
                        if(switchNum.FAN == "4" || switchNum.FAN == "0"){
                            moduleState.FAN = '0'
                        }
                    }
                    
                    if(module.orgDID) {
                        commmandObj = {
                            CTY: 'mr',
                            DID: module.orgDID,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }    
                    } else {
                        commmandObj = {
                            CTY: 'mr',
                            DID: storedCredentials.userPhoneNumber,
                            MAC: module.MAC,
                            DIR: storedCredentials.userPhoneNumber,
                            ...moduleState
                        }

                    }
                }
            }

            NetworkInfo.getIPAddress().then(ipAddress => {
                if(ipAddress){
                    // const splitedLocalIp = ipAddress.split(".")
                    //console.log("Splited IP: ", splitedLocalIp)
                    // const moduleSplitedIp = module.localIp.split(".")
                    const client = TcpSocket.createConnection({port:9998,host: '192.168.200.1', timeout: 2000}, () =>{
                        // console.log("Sock Opened Command");
                        client.write(JSON.stringify(commmandObj));
                        // updateModulesHandler(module)
                    }) 

                    client.on('timeout', ()=> {
                        client.destroy()
                    })

                    client.on('data', function(data) {
                        var res = "";
                        data.map(charCode=> res = res + String.fromCharCode(charCode))
                        const parsedData = JSON.parse(res)
                        
                        client.destroy();
                        
                        if(parsedData.CTY == "mgsRes" && parsedData.STM) {
                            console.log('got');
                            const moduleRestInterval = setInterval(() => {
                                clearInterval(moduleRestInterval)
                                const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                const newState = {STM: parsedData.STM, RTM: parsedData.RTM, FAN: parsedData.FAN, MOD: parsedData.MOD, PWR: parsedData.PWR}
                                const updatedModule = {...modules[index], ...{newState}, ...{isWaitingForRes: false}}
                                clearInterval(commandInterval)
                                var updatedModules = modules;
                                updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                setModules(updatedModules)
                                setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                // console.log('got2');
                                
                            }, 500);
            
                            //console.log(updatedModules)
                            return true
            
                        } else if(parsedData.CTY == "mgsRes" && !parsedData.STM) {
                            //console.log(parsedData.STM)
                            const moduleRestInterval = setInterval(() => {
                                clearInterval(moduleRestInterval)
                                const index = modules.findIndex(module => module.MAC == parsedData.MAC)
                                const updatedModule = {...modules[index], ...{newState: parsedData.STA}, ...{isWaitingForRes: false}}
                                clearInterval(commandInterval)
                                var updatedModules = modules;
                                updatedModules[index] = {...updatedModules[index], ...updatedModule}
                                setModules(updatedModules)
                                setSetModulesHelper(setModulesHelper => setModulesHelper + 1)
                                
                            }, 500);
                            
                            //console.log(updatedModules)
        
                            return true
                        }
        
                    })        
    
                }

            });
            

            
        }

        if(Platform.OS == 'web') {
            onlineModuleCommandHandler(module, switchNum)
        } else {
            try{
                WifiManager.getCurrentWifiSSID().then(ssid=> {
                    if(ssid.substring(0,6) === 'Zitco_'){
                        localModuleCommandHandler(module, switchNum)
                    } else {
                        offlineModuleCommandHandler(module, switchNum)
                        onlineModuleCommandHandler(module, switchNum)
                    }
                })
            } catch (err) {
                console.log('catch')
                offlineModuleCommandHandler(module, switchNum)
                onlineModuleCommandHandler(module, switchNum)
            }
        }

        // NetInfo.fetch().then(state => {
        //     if(Platform.OS !== 'web'){
        //         WifiManager.getCurrentWifiSSID().then(ssid=> {
        //             if(ssid.substring(0,6) === 'Zitco_'){
        //                 localModuleCommandHandler(module, switchNum)
        //             } else if() {
        //                 offlineModuleCommandHandler(module, switchNum)
        //             }
        //         })
        //     }
        //     onlineModuleCommandHandler(module, switchNum)
            
        // });
        
    }

    const styleHandler = (item) => {
        if(item.newState) {
            if(item.isWaitingForRes) {
                if(item.type == 'A1' || item.type == 'A2'){
                    return {...storedCredentials.theme == 'light' ? LightStyles.loadedACCard : DarkStyles.loadedACCard, ...{backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}
                } else if(item.type == 'P' || item.type == 'S1' || item.type == 'S2') {
                    return {...storedCredentials.theme == 'light' ? LightStyles.loadedPlugCard : DarkStyles.loadedPlugCard, ...{backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}
                } else if(item.type == 'S3') {
                    return {...storedCredentials.theme == 'light' ? LightStyles.loadedS3Card : DarkStyles.loadedS3Card, ...{backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}
                } else if(item.type == 'S4') {
                    return {...storedCredentials.theme == 'light' ? LightStyles.loadedS4Card : DarkStyles.loadedS4Card, ...{backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}
                }
            } else {
                if(item.type == 'A1' || item.type == 'A2'){
                    return storedCredentials.theme == 'light' ? LightStyles.loadedACCard : DarkStyles.loadedACCard
                } else if(item.type == 'P' || item.type == 'S1' || item.type == 'S2') {
                    return storedCredentials.theme == 'light' ? LightStyles.loadedPlugCard : DarkStyles.loadedPlugCard
                } else if(item.type == 'S3') {
                    return storedCredentials.theme == 'light' ? LightStyles.loadedS3Card : DarkStyles.loadedS3Card
                } else if(item.type == 'S4') {
                    return storedCredentials.theme == 'light' ? LightStyles.loadedS4Card : DarkStyles.loadedS4Card
                }
            }
        } else if(!item.newState) {
            if(item.type == 'A1' || item.type == 'A2') {
                return storedCredentials.theme == 'light' ? LightStyles.acCard : DarkStyles.acCard
            } else if(item.type == 'P' || item.type == 'S1' || item.type == 'S2') {
                return storedCredentials.theme == 'light' ? LightStyles.plugCard : DarkStyles.plugCard
            } else if(item.type == 'S3') {
                return storedCredentials.theme == 'light' ? LightStyles.s3Card : DarkStyles.s3Card
            } else if(item.type == 'S4') {
                return storedCredentials.theme == 'light' ? LightStyles.s4Card : DarkStyles.s4Card
            }
        }
    }

    const handleIsEdittingModules = (module) => {
        if(isEdittingModules.length == 0) {
            const tempIsEdittingModules = isEdittingModules;
            tempIsEdittingModules.push(module)
            setIsEdittingModules(tempIsEdittingModules)
            setIsEdittingModulesHelper(isEdittingModulesHelper + 1)
            
            fadeIn()
        } else {
            Animated.timing(fadeAnim, {
                toValue: 0,
                duration: 150,
                useNativeDriver: true,
            }).start(({finished})=> {
                var tempIsEdittingModules = isEdittingModules;
                tempIsEdittingModules = []
    
                tempIsEdittingModules.push(module)
                setIsEdittingModuleName([])
                setIsEdittingModules(tempIsEdittingModules)
                setIsEdittingModulesHelper(isEdittingModulesHelper + 1)
                
                fadeIn()
            })
        }

    }
    const handleCancelEditting = (module) => {
        Animated.timing(fadeAnim, {
            toValue: 0,
            duration: 250,
            useNativeDriver: true,
          }).start(({finished}) => {  
                setIsEdittingModuleName([])
                setIsEdittingModules([])
                setIsEdittingModuleNameHelper(isEdittingModuleNameHelper - 1)
          });
    }
    const handleEditModuleName = (module) => {
        const tempIsEdittingModuleName = isEdittingModuleName
        tempIsEdittingModuleName.push(module)
        setIsEdittingModuleName(tempIsEdittingModuleName)
        setIsEdittingModuleNameHelper(isEdittingModuleNameHelper + 1)

        if(storedCredentials.customModulesNames) {
            var storedCustomModulesNames = storedCredentials.customModulesNames
            const index = storedCustomModulesNames.findIndex(moduleItem => moduleItem.MAC == module.MAC)
            if(index != -1) {
                setModuleName(storedCustomModulesNames[index].Name)
            } else {
                if(module.type == 'P') setModuleName(strings().plug)
                else setModuleName(strings().switch)
            }
        } else {
            if(module.type == 'P') setModuleName(strings().plug)
            else setModuleName(strings().switch)
        }
        
    }
    const handleChangeModuleName = (module) => {
        var updatedStoredCredentials
        if(storedCredentials.customModulesNames) {
            var storedCustomModulesNames = storedCredentials.customModulesNames
            const index = storedCustomModulesNames.findIndex(moduleItem => moduleItem.MAC == module.MAC)
            if(index == -1){
                storedCustomModulesNames.push({MAC: module.MAC, Name: moduleName})
                updatedStoredCredentials = {...storedCredentials, ...{customModulesNames: storedCustomModulesNames}}
            } else {
                storedCustomModulesNames[index] = { MAC: module.MAC, Name: moduleName }
                updatedStoredCredentials = {...storedCredentials, ...{customModulesNames: storedCustomModulesNames}}
            }

        } else {
            updatedStoredCredentials = {...storedCredentials, ...{customModulesNames: [{MAC: module.MAC, Name: moduleName}]}}

        }
        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
        .then(()=> {
            setStoredCredentials(updatedStoredCredentials)
            
            NetInfo.fetch().then(state => {
                
                if(state.isConnected) {
                    const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
                    const credentials = { 
                        userPhoneNumber: storedCredentials.userPhoneNumber,
                        data: {newCustomModulesName: updatedStoredCredentials.customModulesNames} 
                    };
                    axios.post(url, credentials)
                    .catch(err => {
                        console.log(err)
                    })
                } 
            });

        })
        .catch(err =>{
            console.log(err);
        })

        handleCancelEditting(module)
    }

    const handleIsEdittingSwitchIcon = (module, switchNum) => {
        if(isEdittingSwitchIcon.length == 0) {
            const tempIsEdittingSwitchIcon = isEdittingSwitchIcon;
            tempIsEdittingSwitchIcon.push({...module, switchNum: switchNum})
            setIsEdittingSwitchIcon(tempIsEdittingSwitchIcon)
            setIsEdittingSwitchIconHelper(isEdittingModulesHelper + 1)
        } else {
            var tempIsEdittingSwitchIcon = isEdittingSwitchIcon;
            tempIsEdittingSwitchIcon = []

            tempIsEdittingSwitchIcon.push({...module, switchNum: switchNum})
            setIsEdittingModuleName([])
            setIsEdittingSwitchIcon(tempIsEdittingSwitchIcon)
            setIsEdittingSwitchIconHelper(isEdittingModulesHelper + 1)
        }
    }
    const handleCancelSwitchIconEditting = (module) => {
        setIsEdittingSwitchIcon([])
        setIsEdittingSwitchIconHelper(isEdittingSwitchIconHelper + 1)
    }
    const handleChangeSwitchIcon = (icon) => {
        var updatedStoredCredentials
        if(storedCredentials.customSwitchesIcons) {
            var tempStoredCustomSwitchesIcons = storedCredentials.customSwitchesIcons
            const index = tempStoredCustomSwitchesIcons.findIndex(moduleItem => moduleItem.MAC == isEdittingSwitchIcon[0].MAC)
            if(index == -1) {
                tempStoredCustomSwitchesIcons.push({MAC: isEdittingSwitchIcon[0].MAC, Switches: [{num: isEdittingSwitchIcon[0].num, icon: icon}]})
                updatedStoredCredentials = {...storedCredentials, ...{customSwitchesIcons: tempStoredCustomSwitchesIcons}}
            } else {
                const switchIndex = tempStoredCustomSwitchesIcons[index].Switches.findIndex(switchItem => switchItem.num == isEdittingSwitchIcon[0].switchNum)
                if(switchIndex == -1) {
                    tempStoredCustomSwitchesIcons[index].Switches.push({num: isEdittingSwitchIcon[0].switchNum, icon: icon})
                    updatedStoredCredentials = {...storedCredentials, ...{customSwitchesIcons: tempStoredCustomSwitchesIcons}}
                } else {
                    tempStoredCustomSwitchesIcons[index].Switches[switchIndex].icon = icon
                    updatedStoredCredentials = {...storedCredentials, ...{customSwitchesIcons: tempStoredCustomSwitchesIcons}}
                }
            }
        } else {
            updatedStoredCredentials = {...storedCredentials, ...{customSwitchesIcons: [{MAC: isEdittingSwitchIcon[0].MAC, Switches: [{num: isEdittingSwitchIcon[0].switchNum, icon: icon}]}]}}
        }
        
        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
        .then(()=> {
            setStoredCredentials(updatedStoredCredentials)
            
            NetInfo.fetch().then(state => {
                
                if(state.isConnected) {
                    const url = envVars.SERVER_URL + envVars.SERVER_PORT + '/users/updateUserInfo';
                    const credentials = { 
                        userPhoneNumber: storedCredentials.userPhoneNumber,
                        data: {newCustomSwitchesIcons: updatedStoredCredentials.customSwitchesIcons} 
                    };
                    axios.post(url, credentials)
                    .catch(err => {
                        console.log(err)
                    })
                } 
            });

        })
        .catch(err =>{
            console.log(err);
        })

    }

    return (
        <View style={storedCredentials.theme == 'light' ? LightStyles.wrapper :  DarkStyles.wrapper}>
            <Modal 
                animationType = 'fade'
                transparent = {true}
                visible = {addModuleModalVisible}
            >
                <View style={{flex: 1, justifyContent: 'center'}}>
                    <View style={storedCredentials.theme == 'light' ? LightStyles.modalView :  DarkStyles.modalView}>
                    <ScrollView>
                        <View style={{...storedCredentials.theme == 'light' ? LightStyles.addModuleModalHeader :  DarkStyles.addModuleModalHeader, ...storedCredentials.language == 'English' && {flexDirection:'row', paddingLeft: 15}}}>
                            <TouchableOpacity 
                                style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper} 
                                onPress={()=> setAddModuleModalVisile(!addModuleModalVisible)}
                                >
                                <AntDesign name="closecircleo" size={28} color="white" />                            
                            </TouchableOpacity>

                            <StyledText style={{...storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText, ...{marginRight: 15}}} > {strings().addDevice} </StyledText>

                        </View>

                        <View style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalBody :  DarkStyles.addModuleModalBody}>
                            <View style={{flexDirection: storedCredentials.language == 'English' ? 'row' : 'row-reverse'}}>
                                <MaterialCommunityIcons name="numeric-1-box" size={24} color="black" />
                                <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalDescriptions :  DarkStyles.addModuleModalDescriptions}>
                                    {strings().putDeviceOnConfigMode}
                                </StyledText>
                            </View>


                        </View>
                            <TouchableOpacity style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtn :  DarkStyles.addModuleModalSubmitBtn} 
                                // onPress={()=> {isAddingModule ? {} : handleAddNewModule()}}
                                onPress={()=>{
                                    setAddModuleModalVisile(!addModuleModalVisible);
                                    setAddModuleModalSecondStepVisible(!addModuleModalSecondStepVisible)
                                }}
                            >
                                {
                                isAddingModule
                                ? <ActivityIndicator size="large"  />
                                : <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtnText :  DarkStyles.addModuleModalSubmitBtnText}> {strings().nextStep} </StyledText>
                                }
                                
                            </TouchableOpacity>
                    </ScrollView>   
                    </View>
                </View>
            </Modal>
            <Modal
                animationType = 'fade'
                transparent = {true}
                visible = {addModuleModalSecondStepVisible}
            >
                <View style={{flex: 1, justifyContent: 'center'}}>
                    <View style={storedCredentials.theme == 'light' ? LightStyles.modalView :  DarkStyles.modalView}>
                        <ScrollView>
                            <View style={{...storedCredentials.theme == 'light' ? LightStyles.addModuleModalHeader :  DarkStyles.addModuleModalHeader, ...storedCredentials.language == 'English' && {flexDirection: 'row', paddingLeft: 15}}}>
                                <TouchableOpacity 
                                    style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper} 
                                    onPress={()=> setAddModuleModalSecondStepVisible(!addModuleModalSecondStepVisible)}
                                    >
                                    <AntDesign name="closecircleo" size={28} color="white" />                            
                                </TouchableOpacity>

                                <StyledText style={{...storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText, ...{marginRight: 15}}} > {strings().addDevice} </StyledText>
                            </View>
                            
                            <View style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalBody :  DarkStyles.addModuleModalBody}>
                                <View style={{flexDirection: storedCredentials.language == 'English' ? 'row' : 'row-reverse', }}>
                                    <MaterialCommunityIcons name="numeric-2-box" size={24} color="black" />
                                    <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalDescriptions :  DarkStyles.addModuleModalDescriptions}>
                                        {strings().connectZITCOCONFIGThroughtWifi}
                                        
                                        {strings().password}
                                    </StyledText>
                                </View>
                            </View>
                            
                            {/* <TouchableOpacity style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtn :  DarkStyles.addModuleModalSubmitBtn} 
                                // onPress={()=> {isAddingModule ? {} : handleAddNewModule()}}
                                onPress={()=>{
                                    setAddModuleModalSecondStepVisible(!addModuleModalSecondStepVisible)
                                    setAddModuleModalThirdStepVisible(!addModuleModalThirdStepVisible)
                                    requestAccessFineLocation()
                                }}
                            >
                                {
                                isAddingModule
                                ? <ActivityIndicator size="large"  />
                                : <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtnText :  DarkStyles.addModuleModalSubmitBtnText}> {strings().nextStep} </StyledText>
                                }
                                
                            </TouchableOpacity> */}

                        </ScrollView>           
                    </View>
                </View>
            </Modal>
            <Modal
                animationType = 'fade'
                transparent = {true}
                visible = {addModuleModalThirdStepVisible}
            >
                <View style={{flex: 1, justifyContent: 'center'}}>
                    <View style={storedCredentials.theme == 'light' ? LightStyles.modalView :  DarkStyles.modalView}>
                        <ScrollView>
                            <View style={{...storedCredentials.theme == 'light' ? LightStyles.addModuleModalHeader :  DarkStyles.addModuleModalHeader, ...storedCredentials.language == 'English' && {flexDirection: 'row', paddingLeft: 15}}}>
                                <TouchableOpacity 
                                    style={storedCredentials.theme == 'light' ? LightStyles.modalHeaderCloseIconWrapper :  DarkStyles.modalHeaderCloseIconWrapper} 
                                    onPress={()=> setAddModuleModalThirdStepVisible(!addModuleModalThirdStepVisible)}
                                    >
                                    <AntDesign name="closecircleo" size={28} color="white" />                            
                                </TouchableOpacity>

                                <BoldStyledText style={{...storedCredentials.theme == 'light' ? LightStyles.modalHeaderText :  DarkStyles.modalHeaderText, ...{marginRight: 15}}} > {strings().addDevice} </BoldStyledText>
                            </View>
                            
                            <View style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalBody :  DarkStyles.addModuleModalBody}>
                                
                                <View style={{flexDirection: storedCredentials.language == 'English' ? 'row' : 'row-reverse' }}>
                                    <MaterialCommunityIcons name="numeric-3-box" size={24} color="black" />
                                    <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalDescriptions :  DarkStyles.addModuleModalDescriptions}>
                                        {strings().chooseNetworkAndEnterItsPassword}
                                    </StyledText>
                                </View>
                                <View style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalDescriptionsUSSIDandPassInputsWrapper :  DarkStyles.addModuleModalDescriptionsUSSIDandPassInputsWrapper}>
                                    {/* <TextInput 
                                        style={storedCredentials.theme == 'light' ? LightStyles.UssidandPassTextInputs :  DarkStyles.UssidandPassTextInputs} 
                                        placeholder='نام شبکه' 
                                        onChangeText={(value) => setSSID(value)  }
                                        value={SSID}
                                    /> */}
                                    <View style={{flex: 1,flexDirection: 'row',justifyContent: 'space-between', alignItems: 'center'}}>
                                        <View style={{width: '85%', justifyContent: 'center', alignItems: 'center'}}>
                                            {isReloadingWifiList ? <ActivityIndicator /> :
                                                <View style={{width: '100%'}}>
                                                    <Dropdown 
                                                        data={dropDownData}
                                                        style={[LightStyles.dropdown, isDropDownFocused && { borderColor: 'blue' }]}
                                                        placeholderStyle={LightStyles.placeholderStyle}
                                                        selectedTextStyle={LightStyles.selectedTextStyle}
                                                        inputSearchStyle={LightStyles.inputSearchStyle}
                                                        iconStyle={LightStyles.iconStyle}
                                                        search
                                                        maxHeight={300}
                                                        labelField="label"
                                                        valueField='value'
                                                        placeholder={isDropDownFocused ? '...' : strings().chooseNetwork}
                                                        searchPlaceholder= {strings().search}
                                                        value={dropDownValue}
                                                        onFocus={()=> setIsDropDownFocused(true)}
                                                        onBlur={()=> setIsDropDownFocused(false)}
                                                        onChange={(item)=> {
                                                            setDropDownValue(item.value)
                                                            setIsDropDownFocused(false)
                                                        }}
                                                        renderLeftIcon={()=> (<AntDesign name="wifi" size={20} color={isDropDownFocused ? 'blue' : 'black'} />)}
                                                    />

                                                </View>
                                            
                                            }

                                        </View>

                                        <TouchableOpacity onPress={()=> isReloadingWifiList ? {} : requestAccessFineLocation()}>
                                            <Ionicons name="reload" size={24} color="black" />
                                        </TouchableOpacity>
                                    </View>

                                    <TextInput 
                                        // style={storedCredentials.theme == 'light' ? LightStyles.UssidandPassTextInputs :  DarkStyles.UssidandPassTextInputs} 
                                        style={{...LightStyles.dropdown, ...{marginTop: 20}}}
                                        placeholder= {strings().placeholderPassword}
                                        onChangeText={(value) => setModemPassword(value) }    
                                        value={modemPassword}
                                    />
                                    <View style={{flexDirection: storedCredentials.language == 'English' ? 'row' : 'row-reverse', marginTop: 5}}> 
                                        <CheckBox
                                            disabled={false}
                                            value={rememberModemInfo}
                                            onValueChange={(newValue) => setRememberModemInfo(newValue)}
                                        />
                                        <StyledText style={{...storedCredentials.theme == 'light' ? LightStyles.addModuleModalDescriptions :  DarkStyles.addModuleModalDescriptions,...{fontSize: 19}}}> {strings().saveModemInfo} </StyledText>

                                    </View>

                                    <View style={{flexDirection: storedCredentials.language == 'English' ? 'row' : 'row-reverse', marginTop: 5}}> 
                                        <CheckBox
                                            disabled={false}
                                            value={offlineConfig}
                                            onValueChange={(newValue) => setOfflineConfig(newValue)}
                                        />
                                        <StyledText style={{...storedCredentials.theme == 'light' ? LightStyles.addModuleModalDescriptions :  DarkStyles.addModuleModalDescriptions,...{fontSize: 19}}}> {strings().offlineConfig} </StyledText>

                                    </View>
                                </View>
                            </View>
                            
                            <TouchableOpacity style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtn :  DarkStyles.addModuleModalSubmitBtn} 
                            onPress={()=> {isAddingModule ? {} : handleAddNewModule()}}
                            >
                                {
                                isAddingModule
                                ? <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtnText :  DarkStyles.addModuleModalSubmitBtnText}> {strings().addingDevice} {addingModulesStep}/10 </StyledText>
                                : <StyledText style={storedCredentials.theme == 'light' ? LightStyles.addModuleModalSubmitBtnText :  DarkStyles.addModuleModalSubmitBtnText}> {strings().addDevice} </StyledText>
                                }
                            
                            </TouchableOpacity>

                        </ScrollView>           
                    </View>
                </View>
            </Modal>
            <View style={{flex: 1}}>
               
                {/* <GestureRecognizer
                    style={{flex: 1}}
                    onSwipeRight={()=> onSwipeRightHandler()}
                    onSwipeLeft={()=> onSwipeLeftHandler()}
                >

                </GestureRecognizer> */}
                
                <FlatList
                    // style={{backgroundColor: 'yellow'}}
                    data={modules}
                    showsVerticalScrollIndicator={false}
                    keyExtractor={item => item.MAC}
                    renderItem=
                    {itemData => 
                        <View>
                            {
                                itemData.item.type == 'P' &&
                                <Card 
                                    // style={itemData.item.newState ? Styles.loadedPlugCard : Styles.plugCard}  
                                    style={styleHandler(itemData.item)} 
                                    activeOpacity = {1}
                                    onLongPress={()=> handleIsEdittingModules(itemData.item)}
                                >
                                    {itemData.item.isWaitingForRes 
                                        ? 
                                            <View style={itemData.item.newState ? {...LightStyles.loadedAcView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}} : {...Styles.acView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}}>
                                                <MaterialCommunityIcons name="update" size={35} color="white" />
                                            </View> 
                                        :
                                            <View style={{flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center' }}>
                                                {
                                                    isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                        <Animated.View style={[{flexDirection: 'row-reverse', maxWidth: '60%'}, {opacity: fadeAnim}]}>
                                                            <View style={{backgroundColor: 'white', flex: 1}}>
                                                                <TextInput 
                                                                    style={{ fontSize: 32, padding:2 }}  
                                                                    value={moduleName}
                                                                    onChangeText={(value) => setModuleName(value) } 
                                                                    maxLength={7}
                                                                />

                                                            </View>
                                                            <View style={{justifyContent: 'center', backgroundColor: 'white', width: '40%', alignItems: 'center'}}>
                                                                <StyledText style={{ fontSize: 18}}> {moduleName.length} / 7 </StyledText>

                                                            </View>
                                                        </Animated.View>
                                                    :
                                                        <View>
                                                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {moduleTypeHandler(itemData)} </StyledText>
                                                        </View>


                                                }
                                                {
                                                    isEdittingModules.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                    <Animated.View style={[{flexDirection: 'row-reverse'}, {opacity: fadeAnim}] }>
                                                    {
                                                        isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                        ?
                                                            <TouchableOpacity   
                                                                style={{paddingHorizontal: 8}}
                                                                onPress={() => handleChangeModuleName(itemData.item)}
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().save} </BoldStyledText>
                                                            </TouchableOpacity>
                                                            
                                                        :
                                                            <TouchableOpacity   
                                                                style={{paddingHorizontal: 8}}
                                                                onPress={()=> handleEditModuleName(itemData.item)}
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().edit} </BoldStyledText>
                                                            </TouchableOpacity>

                                                    }

                                                        <TouchableOpacity 
                                                            style={{paddingHorizontal: 8}} 
                                                            onPress={()=> handleCancelEditting(itemData.item)}    
                                                        >
                                                            <BoldStyledText style={{fontSize: 20}}> {strings().deny} </BoldStyledText>
                                                        </TouchableOpacity>
                                                    </Animated.View>
                                                    :
                                                        <>
                                                            {
                                                                itemData.item.newState ?
                                                                    <View>
                                                                        <Switch
                                                                            // trackColor={{ false: "#767577", true: "#81b0ff" }}
                                                                            // thumbColor={isEnabled ? "#f5dd4b" : "#f4f3f4"}
                                                                            // ios_backgroundColor="#3e3e3e"
                                                                            onValueChange={() => moduleCommandHandler(itemData.item, 0)}
                                                                            value={itemData.item.newState[0] == 0 ? false : true}
                                                                    />
                                                                    </View>
                                                                
                                                                :
                                                                <StyledText style={{fontSize: 20, fontWeight: '400', color: storedCredentials.theme == 'light' ? 'white' : 'gray'}}>{strings().connecting} </StyledText>
                                                            }
                                                        
                                                        </>

                                                }
                                                
                                            </View>
                                    }
                                </Card> 
                            }
                            {
                                itemData.item.type == 'A1' &&
                                <Card  
                                    style={styleHandler(itemData.item)} 
                                    activeOpacity = {1}
                                >
                                    {itemData.item.isWaitingForRes 
                                        ? 
                                            <View style={itemData.item.newState ? {...LightStyles.loadedAcView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}} : {...Styles.acView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}}>
                                                <MaterialCommunityIcons name="update" size={35} color="white" />
                                            </View> 
                                        :
                                            <View style={itemData.item.newState ? {flex: 1, flexDirection: 'column'} : LightStyles.acView}>
                                                {
                                                    itemData.item.newState ?
                                                        <View style={{flex: 1}}>
                                                            <View style={{flex: 1, flexDirection: 'row-reverse', justifyContent: 'center', alignItems: 'center'}}> 
                                                                <View style={{width: '20%'}} >
                                                                {itemData.item.newState.PWR == 1 &&
                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? '#c2ffc2' : '#807f76', borderRadius: 7, flex: 1, width: '100%'}} >

                                                                        {
                                                                            itemData.item.newState.MOD == 0 &&
                                                                                <RadioButton data={radioButtonData} onChange={(mode)=> moduleCommandHandler(itemData.item,{MOD: mode.toString()})} initValue={radioButtonData[0].mode} />
                                                                        }
                                                                        {
                                                                            itemData.item.newState.MOD == 1 &&
                                                                                <RadioButton data={radioButtonData} onChange={(mode)=> moduleCommandHandler(itemData.item,{MOD: mode.toString()})} initValue={radioButtonData[1].mode} />
                                                                        }
                                                                    </View>
                                                                }
                                                                </View>
                                                                    
                                                                <View style={{flex: 1, alignItems: 'center', width: '60%', marginHorizontal: 15, marginRight: 20}}>
                                                                    <View style={{alignItems: 'center', justifyContent: 'center', padding: 5, borderRadius: 20, flexDirection: 'row-reverse'}}>
                                                                        <BoldStyledText style={{color: storedCredentials.theme == 'light' ? 'black' : 'white', fontSize: 25}}> دما اتاق:  </BoldStyledText>
                                                                        <MaterialCommunityIcons name="temperature-celsius" size={30} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                        <BoldStyledText  style={{color: storedCredentials.theme == 'light' ? 'black' : 'white', fontSize: 25}}>  {itemData.item.newState.RTM} </BoldStyledText>
                                                                    </View>
                                                                    
                                                                    {itemData.item.newState.PWR == 1 &&
                                                                        <View style={{justifyContent: 'center', alignItems: 'center', borderRadius: 7, flex: 1, width: '100%'}}>
                                                                            <View style={{height: 50, flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'white' : '#6ee391', width: '100%', borderRadius: 7, borderColor: 'white', borderWidth: 2}}>
                                                                                <TouchableOpacity 
                                                                                    style={{flex: 1,justifyContent: 'center', alignItems: 'center', width:'10%'}}
                                                                                    onPress={() => moduleCommandHandler(itemData.item, {STM: (Number(itemData.item.newState.STM) + 1).toString()})}
                                                                                >
                                                                                        <Entypo name="plus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                                </TouchableOpacity>
                                                                                <View style={{flexDirection: 'row', alignItems: 'center', borderRadius: 10, justifyContent: 'center',paddingRight: 10, width: '50%', marginHorizontal:7 }}>
                                                                                    <BoldStyledText style={{fontSize: 30, color: storedCredentials.theme == 'light' ? 'black' : 'white', textAlign: 'center', borderRadius: 10, flex: 1}} >
                                                                                        {itemData.item.newState.STM}
                                                                                
                                                                                    </BoldStyledText>

                                                                                        
                                                                                    <MaterialCommunityIcons name="temperature-celsius" size={30} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                                </View>
                                                                                <TouchableOpacity 
                                                                                    style={{flex: 1, justifyContent: 'center', alignItems: 'center',margin: 5, width:'10%'}}
                                                                                    onPress={() => moduleCommandHandler(itemData.item, {STM: (Number(itemData.item.newState.STM) - 1).toString()})}
                                                                                >
                                                                                        <Entypo name="minus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'}/>
                                                                                </TouchableOpacity>
                                                                            </View>
                                                                        </View>
                                                                    
                                                                    }

                                                                </View>
                                                            </View> 
                                                            
                                                            <View style={{flex: 1, flexDirection: 'row-reverse', justifyContent: 'center', alignItems:'center'}}>
                                                                <View style={{width: '20%'}}>
                                                                    {
                                                                        itemData.item.newState.PWR == 0 &&
                                                                            <View>
                                                                                <TouchableOpacity 
                                                                                    style={{backgroundColor: '#d30000', margin: 6, padding: 10, borderRadius: 5, alignItems: 'center', height: 50, justifyContent: 'center', borderWidth: 2, borderColor: 'white', width: '100%'}}
                                                                                    onPress={()=> moduleCommandHandler(itemData.item, {PWR: "1"})}    
                                                                                >
                                                                                    <FontAwesome name="power-off" size={30} color="white" />
                                                                                </TouchableOpacity>
                                                                            </View>
                                                                    }
                                                                    {
                                                                        itemData.item.newState.PWR == 1 &&
                                                                            <View>
                                                                                <TouchableOpacity 
                                                                                    style={{backgroundColor: '#6ee391', margin: 6, padding: 10, borderRadius: 5, alignItems: 'center', height: 50, justifyContent: 'center', borderWidth: 2, borderColor: 'white', width: '100%'}}
                                                                                    onPress={()=> moduleCommandHandler(itemData.item, {PWR: "0"})}
                                                                                >
                                                                                    <FontAwesome name="power-off" size={30} color="white" />
                                                                                </TouchableOpacity>
                                                                            </View>
                                                                    }
                                                                </View>
                                                                
                                                                    <View style={{flex: 1, alignItems: 'center', width: '60%', marginHorizontal: 15, marginRight: 20}}>
                                                                    {itemData.item.newState.PWR == 1 &&
                                                                        <View style={{height: 50, flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'white' : '#6ee391', width: '100%', borderRadius: 7, borderColor: 'white', borderWidth: 2}}>
                                                                            <TouchableOpacity
                                                                                style={{flex: 1, justifyContent: 'center',alignItems: 'center', margin: 5, width:'10%'}}
                                                                                onPress={() => {itemData.item.newState.FAN[0] == "0" ? moduleCommandHandler(itemData.item, {FAN: "1"}) : moduleCommandHandler(itemData.item, {FAN: (Number(itemData.item.newState.FAN[0]) + 1).toString()})}}
                                                                            >
                                                                                <MaterialCommunityIcons name="fan-plus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />

                                                                            </TouchableOpacity>

                                                                            <View style={{flexDirection: 'row', alignItems: 'center', borderRadius: 10, justifyContent: 'center',paddingRight: 10, width: '50%', marginHorizontal:7}}>
                                                                                <BoldStyledText style={{fontSize: 30, color: storedCredentials.theme == 'light' ? 'black' : 'white', textAlign: 'center', marginHorizontal: 10, borderRadius: 10, justifyContent: 'center',alignItems: 'center' ,flex: 1}} >
                                                                                    {itemData.item.newState.FAN[0] == 0 ? 'A' : itemData.item.newState.FAN[0]}
                                                                                        
                                                                                </BoldStyledText>

                                                                                <View>
                                                                                    {
                                                                                        itemData.item.newState.FAN[1] == 0 ?
                                                                                            <MaterialCommunityIcons name="fan-off" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                                        :
                                                                                            <MaterialCommunityIcons name="fan" size={35} color="blue" />

                                                                                    }
                                                                                </View> 

                                                                            </View>
                                                                            <TouchableOpacity 
                                                                                style={{flex: 1, justifyContent: 'center', alignItems: 'center', margin: 5, width:'10%'}}
                                                                                onPress={() => {itemData.item.newState.FAN[0] == "0" ? moduleCommandHandler(itemData.item, {FAN: "3"}) : moduleCommandHandler(itemData.item, {FAN: (Number(itemData.item.newState.FAN[0]) - 1).toString()})}}
                                                                            >
                                                                                <MaterialCommunityIcons name="fan-minus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                            </TouchableOpacity>
                                                                            
                                                                        </View>
                                                                    }
                                                                </View>
                                                            </View>
                                                        </View>
                                                    :
                                                        <View style={{justifyContent: 'center'}}>
                                                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {moduleTypeHandler(itemData)} </StyledText>
                                                        </View>
                                                }
                                                {
                                                    !itemData.item.newState &&
                                                    <View style={{ justifyContent: 'center'}}>
                                                        <StyledText style={{fontSize: 20, fontWeight: '400', color: storedCredentials.theme == 'light' ? 'white' : 'gray'}}>{strings().connecting} </StyledText>

                                                    </View>
                                                }
                                            </View>
                                    }
                                
                                </Card> 
                            }
                            {
                                itemData.item.type == 'A2' &&
                                <Card  
                                    style={styleHandler(itemData.item)} 
                                    activeOpacity = {1}
                                >
                                    {itemData.item.isWaitingForRes 
                                        ? 
                                            <View style={itemData.item.newState ? {...LightStyles.loadedAcView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}} : {...Styles.acView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}}>
                                                <MaterialCommunityIcons name="update" size={35} color="white" />
                                            </View> 
                                        :
                                            <View style={itemData.item.newState ? {flex: 1, flexDirection: 'column'} : LightStyles.acView}>
                                                {
                                                    itemData.item.newState ?
                                                        <View style={{flex: 1}}>
                                                            <View style={{flex: 1, flexDirection: 'row-reverse', justifyContent: 'center', alignItems: 'center'}}> 
                                                                <View style={{width: '20%'}} >
                                                                {itemData.item.newState.PWR == 1 &&
                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? '#c2ffc2' : '#807f76', borderRadius: 7, flex: 1, width: '100%'}} >

                                                                        {
                                                                            itemData.item.newState.MOD == 0 &&
                                                                                <RadioButton data={radioButtonData} onChange={(mode)=> moduleCommandHandler(itemData.item,{MOD: mode.toString()})} initValue={radioButtonData[0].mode} />
                                                                        }
                                                                        {
                                                                            itemData.item.newState.MOD == 1 &&
                                                                                <RadioButton data={radioButtonData} onChange={(mode)=> moduleCommandHandler(itemData.item,{MOD: mode.toString()})} initValue={radioButtonData[1].mode} />
                                                                        }
                                                                    </View>
                                                                }
                                                                </View>
                                                                    
                                                                <View style={{flex: 1, alignItems: 'center', width: '60%', marginHorizontal: 15, marginRight: 20}}>
                                                                    <View style={{alignItems: 'center', justifyContent: 'center', padding: 5, borderRadius: 20, flexDirection: 'row-reverse'}}>
                                                                        <BoldStyledText style={{color: storedCredentials.theme == 'light' ? 'black' : 'white', fontSize: 25}}> دما اتاق:  </BoldStyledText>
                                                                        <MaterialCommunityIcons name="temperature-celsius" size={30} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                        <BoldStyledText  style={{color: storedCredentials.theme == 'light' ? 'black' : 'white', fontSize: 25}}>  {itemData.item.newState.RTM} </BoldStyledText>
                                                                    </View>
                                                                    
                                                                    {itemData.item.newState.PWR == 1 &&
                                                                        <View style={{justifyContent: 'center', alignItems: 'center', borderRadius: 7, flex: 1, width: '100%'}}>
                                                                            <View style={{height: 50, flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'white' : '#6ee391', width: '100%', borderRadius: 7, borderColor: 'white', borderWidth: 2}}>
                                                                                <TouchableOpacity 
                                                                                    style={{flex: 1, justifyContent: 'center', alignItems: 'center',margin: 5, width:'10%'}}
                                                                                    onPress={() => moduleCommandHandler(itemData.item, {STM: (Number(itemData.item.newState.STM) + 1).toString()})}
                                                                                >
                                                                                        <Entypo name="plus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                                </TouchableOpacity>
                                                                                <View style={{flexDirection: 'row', alignItems: 'center', borderRadius: 10, justifyContent: 'center',paddingRight: 10, width: '50%', marginHorizontal:7 }}>

                                                                                    <BoldStyledText style={{fontSize: 30, color: storedCredentials.theme == 'light' ? 'black' : 'white', textAlign: 'center', borderRadius: 10, flex: 1}} >
                                                                                        {itemData.item.newState.STM}
                                                                                
                                                                                    </BoldStyledText>
                                                                                        
                                                                                    <MaterialCommunityIcons name="temperature-celsius" size={30} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                                </View>
                                                                                <TouchableOpacity 
                                                                                    style={{flex: 1, justifyContent: 'center', alignItems: 'center',margin: 5, width:'10%'}}
                                                                                    onPress={() => moduleCommandHandler(itemData.item, {STM: (Number(itemData.item.newState.STM) - 1).toString()})}
                                                                                >
                                                                                        <Entypo name="minus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'}/>
                                                                                </TouchableOpacity>
                                                                            </View>
                                                                        </View>
                                                                    
                                                                    }

                                                                </View>
                                                            </View> 
                                                            
                                                            <View style={{flex: 1, flexDirection: 'row-reverse', justifyContent: 'center', alignItems:'center'}}>
                                                                <View style={{width: '20%'}}>
                                                                    {
                                                                        itemData.item.newState.PWR == 0 &&
                                                                            <View>
                                                                                <TouchableOpacity 
                                                                                    style={{backgroundColor: '#d30000', margin: 6, padding: 10, borderRadius: 5, alignItems: 'center', height: 50, justifyContent: 'center', borderWidth: 2, borderColor: 'white', width: '100%'}}
                                                                                    onPress={()=> moduleCommandHandler(itemData.item, {PWR: "1"})}    
                                                                                >
                                                                                    <FontAwesome name="power-off" size={30} color="white" />
                                                                                </TouchableOpacity>
                                                                            </View>
                                                                    }
                                                                    {
                                                                        itemData.item.newState.PWR == 1 &&
                                                                            <View>
                                                                                <TouchableOpacity 
                                                                                    style={{backgroundColor: '#6ee391', margin: 6, padding: 10, borderRadius: 5, alignItems: 'center', height: 50, justifyContent: 'center', borderWidth: 2, borderColor: 'white', width: '100%'}}
                                                                                    onPress={()=> moduleCommandHandler(itemData.item, {PWR: "0"})}
                                                                                >
                                                                                    <FontAwesome name="power-off" size={30} color="white" />
                                                                                </TouchableOpacity>
                                                                            </View>
                                                                    }
                                                                </View>
                                                                
                                                                <View style={{flex: 1, alignItems: 'center', width: '60%', marginHorizontal: 15, marginRight: 20}}>
                                                                    {itemData.item.newState.PWR == 1 &&
                                                                        <View style={{height: 50, flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'white' : '#6ee391', width: '100%', borderRadius: 7, borderColor: 'white', borderWidth: 2}}>
                                                                            <TouchableOpacity
                                                                                style={{flex: 1, justifyContent: 'center',alignItems: 'center', margin: 5, width:'10%'}}
                                                                                onPress={() => {itemData.item.newState.FAN[0] == "0" ? moduleCommandHandler(itemData.item, {FAN: "5"}) : moduleCommandHandler(itemData.item, {FAN: (Number(itemData.item.newState.FAN[0]) + 1).toString()})}}
                                                                            >
                                                                                <MaterialCommunityIcons name="fan-plus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />

                                                                            </TouchableOpacity>

                                                                            <View style={{flexDirection: 'row', alignItems: 'center', borderRadius: 10, justifyContent: 'center',paddingRight: 10, width: '50%', marginHorizontal:7}}>
                                                                                <BoldStyledText style={{fontSize: 30, color: storedCredentials.theme == 'light' ? 'black' : 'white', textAlign: 'center', marginHorizontal: 10, borderRadius: 10, flex: 1}} >
                                                                                    {itemData.item.newState.FAN[0] == 0 ? 'A' : itemData.item.newState.FAN[0]}
                                                                                        
                                                                                </BoldStyledText>

                                                                                <View>
                                                                                    {
                                                                                        itemData.item.newState.FAN[1] == 0 ?
                                                                                            <MaterialCommunityIcons name="fan-off" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                                        :
                                                                                            <MaterialCommunityIcons name="fan" size={35} color="blue" />

                                                                                    }
                                                                                </View> 

                                                                            </View>
                                                                            <TouchableOpacity 
                                                                                style={{flex: 1, justifyContent: 'center', alignItems: 'center', margin: 5, width:'10%'}}
                                                                                onPress={() => {itemData.item.newState.FAN[0] == "0" ? moduleCommandHandler(itemData.item, {FAN: "4"}) : moduleCommandHandler(itemData.item, {FAN: (Number(itemData.item.newState.FAN[0]) - 1).toString()})}}
                                                                            >
                                                                                <MaterialCommunityIcons name="fan-minus" size={35} color= {storedCredentials.theme == 'light' ? 'black' : 'white'} />
                                                                            </TouchableOpacity>
                                                                            
                                                                        </View>
                                                                    }
                                                                </View>
                                                            </View>
                                                        </View>
                                                    :
                                                        <View style={{justifyContent: 'center'}}>
                                                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {moduleTypeHandler(itemData)} </StyledText>
                                                        </View>
                                                }
                                                {
                                                    !itemData.item.newState &&
                                                    <View style={{ justifyContent: 'center'}}>
                                                        <StyledText style={{fontSize: 20, fontWeight: '400', color: storedCredentials.theme == 'light' ? 'white' : 'gray'}}>{strings().connecting} </StyledText>

                                                    </View>
                                                }
                                            </View>
                                    }
                                
                                </Card> 
                            }                            
                            
                            {
                                itemData.item.type == 'S1' &&
                                <Card  
                                    // style={itemData.item.newState ? Styles.loadedPlugCard : Styles.plugCard}  
                                    style={styleHandler(itemData.item)} 
                                    activeOpacity = {1}
                                    onLongPress={()=> handleIsEdittingModules(itemData.item)}
                                >
                                    {itemData.item.isWaitingForRes 
                                        ? 
                                        <View style={itemData.item.newState ? {...LightStyles.loadedAcView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}} : {...Styles.acView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}}>
                                            <MaterialCommunityIcons name="update" size={35} color="white" />
                                        </View> 
                                        :
                                            <View style={{flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center' }}>
                                                {
                                                    isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                        <Animated.View style={[{flexDirection: 'row-reverse', maxWidth: '60%'}, {opacity: fadeAnim}]}>
                                                            <View style={{backgroundColor: 'white',flex: 1}}>
                                                                <TextInput 
                                                                    style={{ fontSize: 32, padding:2 }}  
                                                                    value={moduleName}
                                                                    onChangeText={(value) => setModuleName(value) } 
                                                                    maxLength={7}
                                                                />

                                                            </View>
                                                            <View style={{justifyContent: 'center', backgroundColor: 'white', width: '40%', alignItems: 'center'}}>
                                                                <StyledText style={{ fontSize: 18}}> {moduleName.length} / 7 </StyledText>

                                                            </View>
                                                        </Animated.View>
                                                    :
                                                        <View>
                                                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {moduleTypeHandler(itemData)} </StyledText>
                                                        </View>


                                                }
                                                {
                                                    isEdittingModules.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                        <Animated.View style={[{flexDirection: 'row-reverse'}, {opacity: fadeAnim}] }>
                                                        {
                                                            isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                            ?
                                                                <TouchableOpacity   
                                                                    style={{paddingHorizontal: 8}}
                                                                    onPress={() => handleChangeModuleName(itemData.item)}
                                                                >
                                                                    <BoldStyledText style={{fontSize: 20}}> {strings().save} </BoldStyledText>
                                                                </TouchableOpacity>
                                                                
                                                            :
                                                                <TouchableOpacity   
                                                                    style={{paddingHorizontal: 8}}
                                                                    onPress={()=> handleEditModuleName(itemData.item)}
                                                                >
                                                                    <BoldStyledText style={{fontSize: 20}}> {strings().edit} </BoldStyledText>
                                                                </TouchableOpacity>

                                                        }

                                                            <TouchableOpacity 
                                                                style={{paddingHorizontal: 8}} 
                                                                onPress={()=> handleCancelEditting(itemData.item)}    
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().deny} </BoldStyledText>
                                                            </TouchableOpacity>
                                                        </Animated.View>
                                                    :
                                                        <>
                                                            {
                                                                itemData.item.newState ?
                                                                    <>
                                                                    {isEdittingSwitchIcon.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1 ? 
                                                                        <View style={{flex: 1,flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between', marginRight: 10}}>
                                                                            <View>
                                                                                <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                    <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, isEdittingSwitchIcon[0].switchNum)} size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                                </View>
                                                                            </View>

                                                                            <View style={{flexDirection: 'row', justifyContent: 'space-around', marginHorizontal: 8, flex: 1}}>
                                                                                <TouchableOpacity onPress={()=> handleChangeSwitchIcon('lightbulb-on')}>
                                                                                    <MaterialCommunityIcons name="lightbulb-on" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                                </TouchableOpacity>
                                                                                <TouchableOpacity onPress={()=> handleChangeSwitchIcon("wall-sconce")}>
                                                                                    <MaterialCommunityIcons name="wall-sconce" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                                </TouchableOpacity>
                                                                                <TouchableOpacity onPress={()=> handleChangeSwitchIcon("chandelier")}>
                                                                                    <MaterialCommunityIcons name="chandelier" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                                </TouchableOpacity>
                                                                            </View>

                                                                            <View style={{alignItems: 'center'}}>
                                                                                <TouchableOpacity onPress={()=> handleCancelSwitchIconEditting(itemData.item)}>
                                                                                    <BoldStyledText style={{fontSize: 15}}> {strings().back} </BoldStyledText>
                                                                                </TouchableOpacity>
                                                                            </View>
                                                                        </View>
                                                                    :
                                                                        <View style={{flex: 1, flexDirection: 'row-reverse', justifyContent: 'space-around'}} >
                                                                            {/* <Switch
                                                                                // trackColor={{ false: "#767577", true: "#81b0ff" }}
                                                                                // thumbColor={isEnabled ? "#f5dd4b" : "#f4f3f4"}
                                                                                // ios_backgroundColor="#3e3e3e"
                                                                                onValueChange={() => moduleCommandHandler(itemData.item, 0)}
                                                                                value={itemData.item.newState[0] == 0 ? false : true}
                                                                            /> */}
                                                                            <TouchableOpacity
                                                                                onPress={() => moduleCommandHandler(itemData.item, 1)}
                                                                                onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 1)}
                                                                            >
                                                                                    
                                                                                    {itemData.item.newState[1] == 0 ? 
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 1)} size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                                        </View>
                                                                                    :
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 1)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                        </View>
                                                                                    } 
                                                                                
                                                                            </TouchableOpacity>
                                                                        </View>
                                                                    
                                                                    }
                                                                    </>
                                                                :
                                                                <StyledText style={{fontSize: 20, fontWeight: '400', color: storedCredentials.theme == 'light' ? 'white' : 'gray'}}>{strings().connecting} </StyledText>

                                                            }

                                                        </>
                                                }
                                            </View>
                                    }
                                </Card> 
                            }
                            
                            {
                                itemData.item.type == 'S2' &&
                                <Card 
                                    // style={itemData.item.newState ? Styles.loadedPlugCard : Styles.plugCard}  
                                    style={styleHandler(itemData.item)} 
                                    activeOpacity = {1}
                                    onLongPress={()=> handleIsEdittingModules(itemData.item)}
                                >
                                    {itemData.item.isWaitingForRes 
                                        ? 
                                            <View style={itemData.item.newState ? {...LightStyles.loadedAcView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}} : {...Styles.acView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}}>
                                                <MaterialCommunityIcons name="update" size={35} color="white" />
                                            </View> 
                                        :
                                            <View style={{flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center' }}>
                                                {
                                                    isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                        <Animated.View style={[{flexDirection: 'row-reverse', maxWidth: '60%'}, {opacity: fadeAnim}]}>
                                                            <View style={{backgroundColor: 'white', flex: 1}}>
                                                                <TextInput 
                                                                    style={{ fontSize: 32, padding:2 }}  
                                                                    value={moduleName}
                                                                    onChangeText={(value) => setModuleName(value) } 
                                                                    maxLength={7}
                                                                />

                                                            </View>
                                                            <View style={{justifyContent: 'center', backgroundColor: 'white', width: '40%', alignItems: 'center'}}>
                                                                <StyledText style={{ fontSize: 18}}> {moduleName.length} / 7 </StyledText>

                                                            </View>
                                                        </Animated.View>
                                                    :
                                                        <View>
                                                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {moduleTypeHandler(itemData)} </StyledText>
                                                        </View>

                                                }
                                                {
                                                    isEdittingModules.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                    <Animated.View style={[{flexDirection: 'row-reverse'}, {opacity: fadeAnim}] }>
                                                    {
                                                        isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                        ?
                                                            <TouchableOpacity   
                                                                style={{paddingHorizontal: 8}}
                                                                onPress={() => handleChangeModuleName(itemData.item)}
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().save} </BoldStyledText>
                                                            </TouchableOpacity>
                                                            
                                                        :
                                                            <TouchableOpacity   
                                                                style={{paddingHorizontal: 8}}
                                                                onPress={()=> handleEditModuleName(itemData.item)}
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().edit} </BoldStyledText>
                                                            </TouchableOpacity>

                                                    }
                                                        <TouchableOpacity 
                                                            style={{paddingHorizontal: 8}} 
                                                            onPress={()=> handleCancelEditting(itemData.item)}    
                                                        >
                                                            <BoldStyledText style={{fontSize: 20}}> {strings().deny} </BoldStyledText>
                                                        </TouchableOpacity>
                                                    </Animated.View>
                                                    :
                                                    <>
                                                        {
                                                            itemData.item.newState ?
                                                            <>
                                                                {isEdittingSwitchIcon.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1 ? 
                                                                    <View style={{flex: 1,flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between', marginRight: 10}}>
                                                                        <View>
                                                                            <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, isEdittingSwitchIcon[0].switchNum)} size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </View>
                                                                        </View>

                                                                        <View style={{flexDirection: 'row', justifyContent: 'space-around', marginHorizontal: 8, flex: 1}}>

                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon('lightbulb-on')}>
                                                                                <MaterialCommunityIcons name="lightbulb-on" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon("wall-sconce")}>
                                                                                <MaterialCommunityIcons name="wall-sconce" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon("chandelier")}>
                                                                                <MaterialCommunityIcons name="chandelier" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                        </View>

                                                                        <View style={{alignItems: 'center'}}>
                                                                            <TouchableOpacity onPress={()=> handleCancelSwitchIconEditting(itemData.item)}>
                                                                                <BoldStyledText style={{fontSize: 15}}> {strings().back} </BoldStyledText>
                                                                            </TouchableOpacity>
                                                                        </View>
                                                                    </View>                                                            
                                                                :
                                                                    <View style={{flex:1, flexDirection: 'row', justifyContent:'space-around'}}>
                                                                        <TouchableOpacity
                                                                            onPress={() => moduleCommandHandler(itemData.item, 2)}
                                                                            onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 2)}
                                                                        >
                                                                                
                                                                                {itemData.item.newState[2] == 0 ? 
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 2)} size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                                    </View>
                                                                                :
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 2)} size={35} color= {storedCredentials.theme == 'light' ? 'goldenrod' : '#e88804'} />
                                                                                    </View>
                                                                                } 
                                                                            
                                                                        </TouchableOpacity>
                                                                        <TouchableOpacity
                                                                            onPress={() => moduleCommandHandler(itemData.item, 0)}
                                                                            onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 0)}
                                                                        >
                                                                                
                                                                                {itemData.item.newState[0] == 0 ? 
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 0)} size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                                    </View>
                                                                                :
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 0)} size={35} color= {storedCredentials.theme == 'light' ? 'goldenrod' : '#e88804'} />
                                                                                    </View>
                                                                                } 
                                                                            
                                                                        </TouchableOpacity>
                                                                    </View>

                                                                }
                                                            </>
                                                            :
                                                            <StyledText style={{fontSize: 20, fontWeight: '400', color: storedCredentials.theme == 'light' ? 'white' : 'gray'}}>{strings().connecting} </StyledText>
        
                                                        }
                                                    
                                                    </>

                                                }
                                            </View>
                                    }
                                </Card> 
                            }
                            {
                                itemData.item.type == 'S3' &&
                                <Card   
                                    // style={itemData.item.newState ? Styles.loadedS3Card : Styles.s3Card}  
                                    style={styleHandler(itemData.item)} 
                                    activeOpacity = {1}
                                    onLongPress={()=> handleIsEdittingModules(itemData.item)}
                                >
                                    {itemData.item.isWaitingForRes 
                                        ? 
                                            <View style={itemData.item.newState ? {...LightStyles.loadedAcView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}} : {...Styles.acView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}}>
                                                <MaterialCommunityIcons name="update" size={35} color="white" />
                                            </View> 
                                        :
                                            <View style={{flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center' }}>
                                                {
                                                    isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                        <Animated.View style={[{flexDirection: 'row-reverse', maxWidth: '60%'}, {opacity: fadeAnim}]}>
                                                            <View style={{backgroundColor: 'white',flex: 1}}>
                                                                <TextInput 
                                                                    style={{ fontSize: 32, padding:2 }}  
                                                                    value={moduleName}
                                                                    onChangeText={(value) => setModuleName(value) } 
                                                                    maxLength={7}
                                                                />

                                                            </View>
                                                            <View style={{justifyContent: 'center', backgroundColor: 'white', width: '40%', alignItems: 'center'}}>
                                                                <StyledText style={{ fontSize: 18}}> {moduleName.length} / 7 </StyledText>

                                                            </View>
                                                        </Animated.View>
                                                    :
                                                        <View> 
                                                            <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {moduleTypeHandler(itemData)} </StyledText>
                                                        </View>

                                                }
                                                {
                                                    isEdittingModules.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                    ?
                                                        <Animated.View style={[{flexDirection: 'row-reverse'}, {opacity: fadeAnim}] }>
                                                            {
                                                                isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                                ?
                                                                    <TouchableOpacity   
                                                                        style={{paddingHorizontal: 8}}
                                                                        onPress={() => handleChangeModuleName(itemData.item)}
                                                                    >
                                                                        <BoldStyledText style={{fontSize: 20}}> {strings().save} </BoldStyledText>
                                                                    </TouchableOpacity>
                                                                    
                                                                :
                                                                    <TouchableOpacity   
                                                                        style={{paddingHorizontal: 8}}
                                                                        onPress={()=> handleEditModuleName(itemData.item)}
                                                                    >
                                                                        <BoldStyledText style={{fontSize: 20}}> {strings().edit} </BoldStyledText>
                                                                    </TouchableOpacity>

                                                            }

                                                            <TouchableOpacity 
                                                                style={{paddingHorizontal: 8}} 
                                                                onPress={()=> handleCancelEditting(itemData.item)}    
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().deny} </BoldStyledText>
                                                            </TouchableOpacity>
                                                        </Animated.View>
                                                    :
                                                    <>

                                                        {
                                                            itemData.item.newState 
                                                            ?
                                                            <>
                                                                {isEdittingSwitchIcon.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1 ? 
                                                                    <View style={{flex: 1,flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between', marginRight: 10}}>
                                                                        <View>
                                                                            <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, isEdittingSwitchIcon[0].switchNum)} size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </View>
                                                                        </View>

                                                                        <View style={{flexDirection: 'row', justifyContent: 'space-around', marginHorizontal: 8, flex: 1}}>

                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon('lightbulb-on')}>
                                                                                <MaterialCommunityIcons name="lightbulb-on" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon("wall-sconce")}>
                                                                                <MaterialCommunityIcons name="wall-sconce" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon("chandelier")}>
                                                                                <MaterialCommunityIcons name="chandelier" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                        </View>

                                                                        <View style={{alignItems: 'center'}}>
                                                                            <TouchableOpacity onPress={()=> handleCancelSwitchIconEditting(itemData.item)}>
                                                                                <BoldStyledText style={{fontSize: 15}}> {strings().back} </BoldStyledText>
                                                                            </TouchableOpacity>
                                                                        </View>
                                                                    </View>
                                                                :
                                                                    <View style={{flex:1, flexDirection: 'row', justifyContent:'space-around'}}>
                                                                        <TouchableOpacity
                                                                            onPress={() => moduleCommandHandler(itemData.item, 2)}
                                                                            onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 2)}
                                                                        >
                                                                                
                                                                                {itemData.item.newState[2] == 0 ? 
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 2)} size={35} color={storedCredentials.theme == 'light' ? "gray" : '#a5a5a5'} />
                                                                                    </View>
                                                                                :
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 2)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                    </View>
                                                                                } 
                                                                            
                                                                        </TouchableOpacity>

                                                                        <TouchableOpacity
                                                                            onPress={() => moduleCommandHandler(itemData.item, 1)}
                                                                            onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 1)}
                                                                        >
                                                                                
                                                                                {itemData.item.newState[1] == 0 ? 
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 1)} size={35} color={storedCredentials.theme == 'light' ? "gray" : '#a5a5a5'} />
                                                                                    </View>
                                                                                :
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 1)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                    </View>
                                                                                } 
                                                                            
                                                                        </TouchableOpacity>

                                                                        <TouchableOpacity
                                                                            onPress={() => moduleCommandHandler(itemData.item, 0)}
                                                                            onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 0)}
                                                                        >
                                                                                
                                                                                {itemData.item.newState[0] == 0 ? 
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 0)} size={35} color={storedCredentials.theme == 'light' ? "gray" : '#a5a5a5'} />
                                                                                    </View>
                                                                                :
                                                                                    <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                        <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 0)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                    </View>
                                                                                } 
                                                                            
                                                                        </TouchableOpacity>
                                                                    </View>
                                                                
                                                                }

                                                            </>

                                                            :
                                                                <StyledText style={{fontSize: 20, fontWeight: '400', color: storedCredentials.theme == 'light' ? 'white' : 'gray'}}>{strings().connecting} </StyledText>
                                                        }
                                                    </>
                                                }
                                            </View>
                                    }
                                </Card> 
                            }
                            {
                                itemData.item.type == 'S4' &&
                                <Card 
                                    // style={itemData.item.newState ? Styles.loadedS4Card : Styles.s4Card}  
                                    style={styleHandler(itemData.item)} 
                                    activeOpacity = {1}
                                    onLongPress={()=> handleIsEdittingModules(itemData.item)}

                                >
                                    {itemData.item.isWaitingForRes 
                                    ? 
                                    <View style={itemData.item.newState ? {...LightStyles.loadedAcView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}} : {...Styles.acView, ...{alignItems: 'center', justifyContent: 'center', backgroundColor: storedCredentials.theme == 'light' ? 'blue' : '#64877b'}}}>
                                        <MaterialCommunityIcons name="update" size={35} color="white" />
                                    </View> 
                                    :
                                        <View style={{flexDirection: 'row-reverse', justifyContent: 'space-between', alignItems: 'center' }}>
                                            {
                                                isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                ?
                                                    <Animated.View style={[{flexDirection: 'row-reverse', maxWidth: '60%'}, {opacity: fadeAnim}]}>
                                                        <View style={{backgroundColor: 'white', flex: 1}}>
                                                            <TextInput 
                                                                style={{ fontSize: 32, padding:2 }}  
                                                                value={moduleName}
                                                                onChangeText={(value) => setModuleName(value) } 
                                                                maxLength={7}
                                                            />

                                                        </View>
                                                        <View style={{justifyContent: 'center', backgroundColor: 'white', width: '40%', alignItems: 'center'}}>
                                                            <StyledText style={{ fontSize: 18}}> {moduleName.length} / 7 </StyledText>

                                                        </View>
                                                    </Animated.View>
                                                :
                                                    <View>
                                                        <StyledText style={storedCredentials.theme == 'light' ? LightStyles.cardTitle : DarkStyles.cardTitle}> {moduleTypeHandler(itemData)} </StyledText>
                                                    </View>


                                            }

                                            {
                                                isEdittingModules.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                ?
                                                    <Animated.View style={[{flexDirection: 'row-reverse'}, {opacity: fadeAnim}] }>
                                                    {
                                                        isEdittingModuleName.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1
                                                        ?
                                                            <TouchableOpacity   
                                                                style={{paddingHorizontal: 8}}
                                                                onPress={() => handleChangeModuleName(itemData.item)}
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().save} </BoldStyledText>
                                                            </TouchableOpacity>
                                                            
                                                        :
                                                            <TouchableOpacity   
                                                                style={{paddingHorizontal: 8}}
                                                                onPress={()=> handleEditModuleName(itemData.item)}
                                                            >
                                                                <BoldStyledText style={{fontSize: 20}}> {strings().edit} </BoldStyledText>
                                                            </TouchableOpacity>

                                                    }

                                                    <TouchableOpacity 
                                                        style={{paddingHorizontal: 8}} 
                                                        onPress={()=> handleCancelEditting(itemData.item)}    
                                                    >
                                                        <BoldStyledText style={{fontSize: 20}}> {strings().deny} </BoldStyledText>
                                                    </TouchableOpacity>
                                                    </Animated.View>
                                                :
                                                <>
                                                    {
                                                        itemData.item.newState ?
                                                            <>
                                                                {isEdittingSwitchIcon.findIndex(moduleItem => moduleItem.MAC == itemData.item.MAC) !== -1 ?
                                                                    <View style={{flex: 1,flexDirection: 'row-reverse', alignItems: 'center', justifyContent: 'space-between', marginRight: 10}}>
                                                                        <View>
                                                                            <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, isEdittingSwitchIcon[0].switchNum)} size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </View>
                                                                        </View>

                                                                        <View style={{flexDirection: 'row', justifyContent: 'space-around', marginHorizontal: 8, flex: 1}}>

                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon('lightbulb-on')}>
                                                                                <MaterialCommunityIcons name="lightbulb-on" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon("wall-sconce")}>
                                                                                <MaterialCommunityIcons name="wall-sconce" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                            <TouchableOpacity onPress={()=> handleChangeSwitchIcon("chandelier")}>
                                                                                <MaterialCommunityIcons name="chandelier" size={35} color= {storedCredentials.theme == 'light' ? 'gray' : '#a5a5a5'} />
                                                                            </TouchableOpacity>
                                                                        </View>

                                                                        <View style={{alignItems: 'center'}}>
                                                                            <TouchableOpacity onPress={()=> handleCancelSwitchIconEditting(itemData.item)}>
                                                                                <BoldStyledText style={{fontSize: 15}}> {strings().back} </BoldStyledText>
                                                                            </TouchableOpacity>
                                                                        </View>
                                                                    </View>
                                                                :
                                                                    <View style={{flex:1, flexDirection: 'row', justifyContent:'space-around'}}>
                                                                            <TouchableOpacity
                                                                                onPress={() => moduleCommandHandler(itemData.item, 3)}
                                                                                onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 3)}
                                                                            >
                                                                                    
                                                                                    {itemData.item.newState[3] == 0 ? 
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 3)} size={35} color={storedCredentials.theme == 'light' ? "gray" : '#a5a5a5'} />
                                                                                        </View>
                                                                                    :
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 3)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                        </View>
                                                                                    } 
                                                                                
                                                                            </TouchableOpacity>
                
                                                                            <TouchableOpacity
                                                                                onPress={() => moduleCommandHandler(itemData.item, 2)}
                                                                                onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 2)}
                                                                            >
                                                                                    
                                                                                    {itemData.item.newState[2] == 0 ? 
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 2)} size={35} color={storedCredentials.theme == 'light' ? "gray" : '#a5a5a5'} />
                                                                                        </View>
                                                                                    :
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 2)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                        </View>
                                                                                    } 
                                                                                
                                                                            </TouchableOpacity>
                
                                                                            <TouchableOpacity
                                                                                onPress={() => moduleCommandHandler(itemData.item, 1)}
                                                                                onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 1)}
                                                                            >
                                                                                    
                                                                                    {itemData.item.newState[1] == 0 ? 
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 1)} size={35} color={storedCredentials.theme == 'light' ? "gray" : '#a5a5a5'} />
                                                                                        </View>
                                                                                    :
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 1)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                        </View>
                                                                                    } 
                                                                                
                                                                            </TouchableOpacity>
                
                                                                            <TouchableOpacity
                                                                                onPress={() => moduleCommandHandler(itemData.item, 0)}
                                                                                onLongPress={()=> handleIsEdittingSwitchIcon(itemData.item, 0)}
                                                                            >
                                                                                    
                                                                                    {itemData.item.newState[0] == 0 ? 
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 0)} size={35} color={storedCredentials.theme == 'light' ? "gray" : '#a5a5a5'} />
                                                                                        </View>
                                                                                    :
                                                                                        <View style={{backgroundColor: storedCredentials.theme == 'light' ? 'aqua' : '#3b365a', padding: 5, paddingVertical: 10, borderRadius: 10}}>
                                                                                            <MaterialCommunityIcons name={handleSwitchIcon(itemData.item, 0)} size={35} color={storedCredentials.theme == 'light' ? "goldenrod" : '#e88804'} />
                                                                                        </View>
                                                                                    } 
                                                                                
                                                                            </TouchableOpacity>
                                                                    </View>

                                                                }

                                                            </>
                                                        :
                                                        <StyledText style={{fontSize: 20, fontWeight: '400', color: storedCredentials.theme == 'light' ? 'white' : 'gray'}}>{strings().connecting} </StyledText>
                                                    }   
                                                
                                                </>
                                            }

                                            
                                        </View>
                                    }
                                </Card> 
                            }
                        </View>
                    }

                    // ListHeaderComponent=
                    // {()=>
                        
                            
                    // } 
                >
                </FlatList>
            </View>
        </View>
    )
};


let DarkStyles = {
    wrapper:{
        // justifyContent:'center',
        flex: 1,
        backgroundColor: '#3b3c37'
    },
    plugCard:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#1c1c1a',
        
    },
    loadedPlugCard:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#807f76',
        
    },
    acCard:{
        justifyContent: 'center',
        height: 250,
        backgroundColor: '#1c1c1a',
        
    },
    loadedACCard:{
        justifyContent: 'center',
        height: 250,
        backgroundColor: '#807f76',
    },
    acView:{
        flexDirection: 'row-reverse', flex: 1, justifyContent: 'space-between'
    },
    loadedAcView: {
        flex: 1, justifyContent: 'space-between',
    },
    s3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#1c1c1a',
        
    },
    loadedS3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#807f76',
        
    },
    s4Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#1c1c1a',
        
    },
    loadedS4Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#807f76',
        
    },
    cardTitle:{
        fontSize: 30,
        textAlign: 'right',
        color: 'white'
    },
    addModuleCard:{
        backgroundColor: '#ffffff',
        height: 100,
        alignItems:'center',
        justifyContent:'center'
    },
    modalView:{
        marginVertical: 10,
        marginHorizontal: '5%',
        backgroundColor: "white",
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 50,
        tintColor: 'black',
    },
    addModuleModalHeader:{
        flexDirection: 'row-reverse',
        paddingVertical: 15,
        backgroundColor: '#2b2b28',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: 'center'
    },
    modalHeaderCloseIconWrapper:{
        paddingRight: 15,
        paddingVertical: 10
    },
    modalHeaderText:{
        fontSize: 25,
        fontWeight: '600',
        color: 'white',
    },
    addModuleModalBody:{
        padding: 20,
        backgroundColor: '#b3b2ad',
    },
    addModuleModalDescriptions:{
        fontSize: 18,
        fontWeight: '400',
        margin: 5,
        // textAlign: 'right',
    },
    UssidandPassTextInputs:{
        backgroundColor: '#F5F6FA',
        padding: 10,
        marginHorizontal: 20,
        marginVertical: 10,
        textAlign: 'center',
        borderWidth: 1,
        borderRadius: 20,
        fontSize: 22,
        fontWeight: '300'
    },
    addModuleModalSubmitBtn:{
        backgroundColor: '#807f76',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20
    },
    addModuleModalSubmitBtnText:{
        color: 'white',
        fontSize: 30,
        fontWeight: '600',
        textAlign: 'center'
    },
    addModuleModalDescriptionsUSSIDandPassInputsWrapper:{
        margin: 20,
        marginBottom: 50
    },
    lottie: {
        width: 100,
        height: 100
    }
};
let LightStyles = {
    wrapper:{
        justifyContent:'center',
        flex: 1
    },
    plugCard:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#88b388',
        
    },
    loadedPlugCard:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#c2ffc2',
        
    },
    acCard:{
        justifyContent: 'center',
        height: 225,
        backgroundColor: '#88b388',
        
    },
    loadedACCard:{
        justifyContent: 'center',
        height: 225,
        backgroundColor: '#c2ffc2',
    },
    acView:{
        flexDirection: 'row-reverse', flex: 1,justifyContent: 'space-between'
    },
    loadedAcView: {
        flexDirection: 'row-reverse', flex: 1,justifyContent: 'space-between', alignItems: 'flex-end'
    },
    s3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#88b388',
        
    },
    loadedS3Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#c2ffc2',
        
    },
    s4Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#88b388',
        
    },
    loadedS4Card:{
        justifyContent: 'center',
        height: 100,
        backgroundColor: '#c2ffc2',
        
    },
    cardTitle:{
        fontSize: 30,
        textAlign: 'right',
        color: 'black'
    },
    addModuleCard:{
        backgroundColor: '#ffffff',
        height: 30,
        alignItems:'center',
        justifyContent:'center'
    },
    modalView:{
        marginVertical: 10,
        marginHorizontal: '5%',
        backgroundColor: "white",
        borderRadius: 20,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 50,
        tintColor: 'black',
    },
    addModuleModalHeader:{
        flexDirection: 'row-reverse',
        paddingVertical: 15,
        backgroundColor: '#344a47',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: 'center'
    },
    modalHeaderCloseIconWrapper:{
        paddingRight: 15,
        paddingVertical: 10
    },
    modalHeaderText:{
        fontSize: 25,
        fontWeight: '600',
        color: 'white',
    },
    addModuleModalBody:{
        padding: 20,
    },
    addModuleModalDescriptions:{
        fontSize: 18,
        fontWeight: '400',
        margin: 5,
        // textAlign: 'right',
    },
    UssidandPassTextInputs:{
        backgroundColor: '#F5F6FA',
        padding: 10,
        marginHorizontal: 20,
        marginVertical: 10,
        textAlign: 'center',
        borderWidth: 1,
        borderRadius: 20,
        fontSize: 22,
        fontWeight: '300'
    },
    addModuleModalSubmitBtn:{
        backgroundColor: '#dab2be',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 15,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20
    },
    addModuleModalSubmitBtnText:{
        color: 'white',
        fontSize: 30,
        fontWeight: '600',
        textAlign: 'center'
    },
    addModuleModalDescriptionsUSSIDandPassInputsWrapper:{
        margin: 20,
        marginBottom: 50
    },
    lottie: {
        width: 100,
        height: 100
    },
    dropdown: {
        height: 50,
        borderColor: 'black',
        borderWidth: 0.5,
        borderRadius: 8,
        paddingHorizontal: 8,
    },
    icon: {
        marginRight: 5,
    },
    label: {
        position: 'absolute',
        backgroundColor: 'white',
        left: 22,
        top: 8,
        zIndex: 999,
        paddingHorizontal: 8,
        fontSize: 14,
    },
    placeholderStyle: {
        fontSize: 16,
    },
    selectedTextStyle: {
    fontSize: 16,
    },
    iconStyle: {
        width: 20,
        height: 20,
    },
    inputSearchStyle: {
        height: 40,
        fontSize: 16,
    },
};


export default RoomModules;